/* eslint-disable max-len */

export default {
  errors: {
    global: {
      internal: 'Kesalahan internal',
      not_allowed: 'Tindakan tidak diperbolehkan',
      access_denied: 'Akses ditolak',
      validator_error: 'Kesalahan validator {details}',
      wrong_body: 'Data body salah',
      wrong_token: 'Token salah',
      missing_token: 'Token hilang',
      exclusive_lock: 'Kunci eksklusif',
      access_denied_acl: 'Akses ditolak (ACL)',
      connection_timeout: 'Waktu koneksi habis',
      login_required: 'Diperlukan login',
      not_found: 'Tidak ditemukan',
      wrong_value: 'Nilai salah',
      token_expired: 'Token kedaluarsa',
      service_not_available: 'Layanan tidak tersedia',
      twofa_required: 'Autentikasi 2FA diperlukan',
      missing_login_token: 'Login diperlukan',
    },
    account: {
      banned: 'Akun diblokir',
      wrong_login_or_password: 'Login atau kata sandi salah',
      wrong_login: 'Login salah',
      wrong_password: 'Kata sandi salah',
      blocked: 'Akun diblokir',
      missing_email: 'Alamat email tidak ditetapkan',
      same_password_used: 'Kata sandi yang sama telah digunakan',
      apikey_not_created: 'API Key tidak dibuat',
      apikey_already_created: 'API Key sudah dibuat',
      twofa_not_created: 'Autentikasi 2FA tidak dibuat',
      twofa_already_created: 'Autentikasi 2FA sudah dibuat',
      deletion_already_started: 'Penghapusan akun sudah dimulai',
      wrong_twofa: 'Kode autentikasi 2FA salah',
      external_withdraw_not_available: 'Penarikan eksternal tidak tersedia',
      twofa_limit: 'Batas autentikasi 2FA',
      kyc_wrong_step: 'Langkah KYC salah',
      not_exists: 'Tidak ada',
      kyc_required: 'KYC diperlukan',
      action_not_allowed: 'Tindakan tidak diperbolehkan',
      migration: 'Migrasi',
      wrong_password_pattern: 'Kata sandi harus terdiri dari 8 hingga 64 karakter dan setidaknya memiliki satu: huruf besar, huruf kecil, angka, karakter khusus',
    },
    market: {
      not_enough_funds: 'Dana tidak cukup',
      missing_steam_token: 'Steam trade url hilang',
      missing_steam_id: 'Steam ID hilang',
      wrong_item_status: 'Status item salah',
      item_already_queued: 'Item sudah masuk antrian',
      max_price_limit: 'Batas harga maksimum',
      item_not_available: 'Item tidak tersedia',
      steam_vac_ban: 'Pemblokiran VAC Steam',
      steam_trade_ban: 'Pemblokiran Steam trade',
      steam_private_profile: 'Profil Steam bersifat pribadi',
      steam_private_inventory: 'Inventaris pribadi steam',
      steam_tradehold: 'Penahanan pertukaran steam',
      cannot_check_tradeban: 'Tidak dapat memeriksa larangan pertukaran',
      cannot_check_tradehold: 'Tidak dapat memeriksa penahanan pertukaran',
      wrong_steam_token: 'Token steam salah',
      no_items_found: 'Tidak ada item ditemukan',
      items_limit: 'Batas item',
      instant_sell_disabled: 'Penjualan instan dinonaktifkan',
      plan_not_found: 'Paket tidak ditemukan',
      price_too_low: 'Harga terlalu rendah',
    },
    steam: {
      wrong_tradelink: 'Tautan pertukaran salah',
      private_inventory: 'Inventaris Steam pribadi',
      cannot_check_tradeban: 'Kami tidak dapat memeriksa larangan pertukaran',
      cannot_check_tradehold: 'Kami tidak dapat memeriksa penahanan pertukaran',
      vac_ban: 'Ban VAC',
      trade_ban: 'Larangan pertukaran',
      private_profile: 'Profil Steam pribadi',
      tradehold: 'Larangan pertukaran',
      wrong_token: 'Token salah',
      missing_token: 'Url pertukaran Steam hilang',
      missing_steam_id: 'ID Steam hilang',
      community_ban: 'Ban komunitas',
      economy_ban: 'Larangan ekonomi',
      platform_offline: 'Tidak ada koneksi dengan Steam, server mungkin sedang down. Silakan coba lagi nanti.',
      cannot_check_escrow: 'Tidak dapat memeriksa escrow',
      escrow: 'Anda menggunakan email Steam Guard yang tidak cukup untuk melakukan pertukaran dengan bot kami. Anda harus mengaktifkan Steam Guard seluler untuk dapat melakukan pertukaran dengan bot.',
      fresh_account: 'Anda perlu mengatur profil steam terlebih dahulu',
    },
    mutex: {
      long_lock: 'Kunci lama, coba lagi dalam {ttl} detik',
      exclusive_lock: 'Kunci eksklusif',
    },
    api: {
      missing_apikey: 'API Key hilang',
      missing_secret: 'API Secret hilang',
      wrong_ip_address: 'Alamat IP salah',
      private_ip_address: 'Alamat IP pribadi',
      wrong_apikey: 'Apikey salah',
    },
    record: {
      item_not_found: 'Item tidak ditemukan',
      item_not_owned: 'Item tidak dimiliki',
      own_item: 'Memiliki item',
      there_are_no_records: 'Tidak ada catatan untuk ditampilkan',
      record_already_exists: 'Catatan sudah ada',
      record_not_exists: 'Catatan tidak ada',
      already_exists: 'Sudah ada',
      not_exists: 'Tidak ada',
      not_updated: 'Tidak diperbarui',
      forbidden: 'Dilarang',
    },
    bot: {
      not_found: 'Bot tidak ditemukan',
      not_available: 'Bot tidak tersedia',
    },
    wallet: {
      cannot_transfer_money: 'Tidak dapat mentransfer uang',
      amount_negative: 'Jumlah negatif',
      amount_positive: 'Jumlah positif',
      card_scoring_too_low: 'Skor kartu terlalu rendah',
      not_enough_balance: 'Saldo tidak cukup',
      kyc_window_limit: 'Batas jendela KYC',
      service_window_limit: 'Batas jendela layanan',
      amount_limit: 'Batas jumlah',
      wrong_wallet_address: 'Alamat dompet salah',
      card_not_found: 'Kartu tidak ditemukan',
      cannot_process_transaction: 'Kami tidak dapat memproses transaksi Anda',
      only_past_months_accepted: 'Hanya transaksi beberapa bulan terakhir yang diterima',
      only_visa_allowed: 'Hanya kartu VISA yang diperbolehkan',
      you_cannot_complete_this_action: 'Anda tidak dapat menyelesaikan tindakan ini karena Anda tidak memiliki cukup dana di akun Anda.',
      you_need_to_deposit_at_least_x: 'Anda harus melakukan deposit minimal {x} untuk menyelesaikan tindakan ini.',
    },
    gift_code: {
      not_found: 'Kode tidak ditemukan',
      already_used: 'Kode sudah digunakan',
      own_code: 'Ini adalah kode Anda sendiri',
    },
    partner: {
      subaccount_not_enabled: 'Subakun tidak diaktifkan',
      link_account_first: 'Tautkan akun terlebih dahulu',
      account_already_linked: 'Akun sudah ditautkan',
      wrong_phrase: 'Frasa yang salah',
      cannot_link_yourself: 'Tidak dapat menautkan diri sendiri',
      account_already_exists: 'Akun sudah ada',
    },
    payment: {
      card_scoring: 'Skor kartu terlalu rendah',
      payment_issue: 'Masalah pembayaran',
    },
    auth: {
      failed_to_authenticate: 'Gagal mengautentikasi',
      not_valid_identity: 'Identitas tidak valid',
      authentication_failed: 'Otentikasi gagal',
    },
    social: {
      cannot_create_chat: 'Tidak dapat membuat obrolan',
    },
    support: {
      wrong_status: 'Status salah',
      ticket_limit: 'Batas tiket',
    },
    ipn: {
      verification_issue: 'Masalah verifikasi',
    },
    affiliate: {
      same_code: 'Kode yang sama',
      code_taken: 'Kode ini sudah digunakan',
      not_activated: 'Tidak diaktifkan',
      not_enough_balance: 'Saldo tidak cukup',
    },
    bam: {
      bam_steam_015: 'Bot kami kehilangan sesi Steam. Silakan coba lagi dalam beberapa menit.',
    },
  },
  validator: {
    required: 'Kolom ini wajib diisi.',
    string: 'Kolom ini harus berupa string.',
    stringEmpty: 'Kolom ini tidak boleh kosong.',
    stringMin: 'Panjang kolom ini harus setidaknya {expected} karakter.',
    stringMax: 'Panjang kolom ini harus paling banyak {expected} karakter.',
    stringLength: 'Panjang kolom ini harus sepanjang {expected} karakter.',
    stringPattern: 'Kolom ini tidak sesuai dengan pola yang diminta.',
    stringPatternLatin: 'Harap gunakan karakter latin saja.',
    stringContains: 'Kolom ini harus berisi teks \'{expected}\'.',
    stringEnum: 'Kolom ini tidak cocok dengan salah satu nilai yang diizinkan.',
    stringNumeric: 'Kolom ini harus berupa string numerik.',
    stringAlpha: 'Kolom ini harus berupa string alfabet.',
    stringAlphanum: 'Kolom ini harus berupa string alfanumerik.',
    stringAlphadash: 'Kolom ini harus berupa string alfabet.',
    stringHex: 'Kolom ini harus berupa hex string.',
    stringSingleLine: 'Kolom ini harus berupa string baris tunggal.',
    stringBase64: 'Kolom ini harus berupa string base64.',
    number: 'Kolom ini harus berupa angka.',
    numberMin: 'Kolom ini harus lebih besar dari atau sama dengan {expected}.',
    numberMax: 'Kolom ini harus kurang dari atau sama dengan {expected}.',
    numberEqual: 'Kolom ini harus sama dengan {expected}.',
    numberNotEqual: 'Kolom ini tidak boleh sama dengan {expected}.',
    numberInteger: 'Kolom ini harus berupa bilangan bulat.',
    numberPositive: 'Kolom ini harus berupa angka positif.',
    numberNegative: 'Kolom ini harus berupa angka negatif.',
    array: 'Kolom ini harus berupa array.',
    arrayEmpty: 'Kolom ini tidak boleh berupa array kosong.',
    arrayMin: 'Kolom ini harus berisi setidaknya item {expected}.',
    arrayMax: 'Kolom ini harus berisi kurang dari atau sama dengan item {expected}.',
    arrayLength: 'Kolom ini harus berisi item {expected}.',
    arrayContains: 'Kolom ini harus berisi item \'{expected}\'.',
    arrayUnique: 'Nilai \'{actual}\' tidak sama dengan nilai \'{expected}\'.',
    arrayEnum: 'Nilai \'{actual}\' tidak sama dengan nilai \'{expected}\'.',
    tuple: 'Kolom ini harus berupa array.',
    tupleEmpty: 'Kolom ini tidak boleh berupa array kosong.',
    tupleLength: 'Kolom ini harus berisi item {expected}.',
    boolean: 'Kolom ini harus berupa boolean.',
    currency: 'Kolom ini harus berupa format mata uang yang valid',
    date: 'Kolom ini harus berupa Tanggal.',
    dateMin: 'Kolom ini harus lebih besar dari atau sama dengan {expected}.',
    dateMax: 'Kolom ini harus kurang dari atau sama dengan {expected}.',
    enumValue: 'Nilai kolom \'{expected}\' ini tidak cocok dengan nilai yang diizinkan.',
    equalValue: 'Nilai kolom ini harus sama dengan \'{expected}\'.',
    equalField: 'Nilai kolom ini harus sama dengan nilai kolom \'{expected}\'.',
    forbidden: 'Kolom ini dilarang.',
    function: 'Kolom ini harus berupa fungsi.',
    email: 'Kolom ini harus berupa email yang valid.',
    emailEmpty: 'Kolom ini tidak boleh kosong.',
    emailMin: 'Panjang kolom ini harus setidaknya sepanjang {expected} karakter.',
    emailMax: 'Panjang kolom ini harus paling banyak {expected} karakter.',
    luhn: 'Kolom ini harus berupa checksum luhn yang valid.',
    mac: 'Kolom ini harus berupa alamat MAC yang valid.',
    object: 'Kolom ini harus berupa Objek.',
    objectStrict: 'Objek ini berisi kunci terlarang: \'{actual}\'.',
    objectMinProps: 'Objek ini harus mengandung setidaknya properti {expected}.',
    objectMaxProps: 'Objek ini harus mengandung paling banyak properti {expected}.',
    url: 'Kolom ini harus berupa URL yang valid.',
    urlEmpty: 'Kolom ini tidak boleh kosong.',
    uuid: 'Kolom ini bukan format kode yang valid.',
    uuidVersion: 'Kolom ini harus berupa versi UUID yang valid yang disediakan.',
    classInstanceOf: 'Kolom ini harus berupa instance dari kelas \'{expected}\'.',
    objectID: 'Kolom ini harus berupa ObjectID yang valid',
    record: 'Kolom ini harus berupa Objek.',
  },
  body: {
    language: 'Bahasa',
    currency: 'Mata uang',
    currency_warning: 'Semua operasi dilakukan dalam dolar AS, mata uang selain USD dikonversi dari USD dan hanya mengubah cara halaman divisualisasikan. Currency exchange rate changes may increase or decrease your balance.',
    choose_game: 'Pilih permainan',
    slider: {
      title_1: 'Tingkatkan gaya Anda,',
      title_2: 'mendominasi permainan',
      content_1: 'Temukan koleksi skin terbaik',
      content_2: 'Untuk meningkatkan pengalaman bermain game Anda.',
      tile_1: 'Maksimalkan pengalaman bermain game Anda',
      tile_2: 'Dapatkan nilai terbaik untuk uang Anda',
      tile_3: 'Nikmati perdagangan yang aman dan lancar',
    },
    footer_description: 'Di BitSkins, kami berdedikasi untuk menyediakan platform yang aman dan terjamin bagi para gamer untuk membeli dan menjual item dari game-game populer target CS2, Dota 2, Rust dan TF2. Sejak peluncuran kami pada tahun 2015, kami telah berhasil melayani jutaan pelanggan yang puas, dan komitmen kami terhadap keselamatan dan keamanan tetap lebih kuat dari sebelumnya.',
    footer_disclaimer: '© 2015 - {year} BitSkins. Didukung oleh Steam. Tidak berafiliasi dengan Valve Corp.',
    footer_email_support: 'Jika Anda membutuhkan dukungan',
    footer_email_security: 'Jika Anda ingin melaporkan bug',
    footer_email_partnership: 'Jika Anda ingin bekerja sama',
    market: 'Pasar',
    cart: 'Keranjang belanja',
    cart_empty: 'Keranjang Anda kosong',
    clear_cart: 'Kosongkan keranjang',
    checkout: 'Pembayaran',
    in_the_cart: 'di dalam keranjang',
    total: 'Total',
    go_to_market: 'Pergi ke pasar',
    trustpilot_alt: 'Trustpilot dengan {stars} bintang dan ulasan {reviews}',
    reload_website: 'Muat ulang situs web!',
    app_error: 'Kesalahan aplikasi: {error}',
    latest_articles: 'Artikel terbaru',
    steam_login: 'Masuk dengan steam',
  },
  maintenance: {
    we_will_be_back_soon: 'Kami akan segera kembali',
    we_are_down_for_maintenance: 'Kami sedang dalam masa pemeliharaan, tetapi kami akan segera kembali online.',
    sorry_for_the_inconvenience: 'Mohon maaf atas ketidaknyamanan ini dan sampai jumpa lagi!',
  },
  account: {
    email: {
      required: 'Alamat email diperlukan',
      required_for_this_payment_method: 'Anda tidak dapat menggunakan metode pembayaran ini karena Anda belum mengatur alamat email Anda.',
      you_can_start_now: 'Anda dapat memulai proses pengaturan sekarang.',
      setup: 'Siapkan email',
    },
    add_funds: 'Tambahkan dana',
    my_store: 'Toko saya',
    selling: 'Menjual',
    transactions: 'Transaksi',
    settings: 'Pengaturan',
    steam_settings: {
      open_settings: 'Buka pengaturan',
      open_steam_settings: 'Buka profil steam',
      what_is_steam_guard: 'Apa yang dimaksud dengan Steam Guard?',
      inventory_status: 'Status inventaris',
      profile_status: 'Status profil',
      change_trade_link: 'Ubah tautan perdagangan',
    },
    logout: 'Keluar',
    inventory: 'Persediaan',
    banned: {
      you_are_banned: 'Anda telah diblokir;',
      your_account_has_been_banned: 'Akun Anda telah diblokir karena melanggar peraturan kami',
      your_account_has_been_blocked: 'Akun Anda telah diblokir karena melanggar peraturan kami',
      if_you_believe: 'Jika Anda yakin itu adalah kesalahan, Anda dapat menghubungi kami di <span class="text-cp">support{\'@\'}bitskins.com</span>',
      terms_of_use: 'Ketentuan Penggunaan',
    },
    account_blocked: 'Akun <span class="text-cr">diblokir</span>',
    api_access: 'Akses API',
  },
  balance: {
    wallet: 'Dompet',
    withdraw: 'Penarikan',
    withdraw_to: 'Tarik ke',
    withdraw_again: 'Tarik lagi',
    withdrawable: 'Dapat ditarik',
    total: 'Total',
    balance: 'Saldo',
    deposits_and_sales: 'Setoran dan penjualan',
    proceeds_from_sales: 'Hasil dari penjualan',
    deposit: 'Deposit',
    locked: 'Terkunci',
    funds_locked: 'Dana terkunci dalam transaksi',
    pending_withdrawals: 'Penarikan yang tertunda',
    thank_you_for_your_payment: 'Terima kasih atas pembayaran Anda',
    your_money_will_arrive_soon: 'Dana Anda akan segera masuk',
    your_payment_is_still_processing: 'Pembayaran Anda masih dalam proses, tetapi dana akan segera masuk ke akun Anda.',
    in_case_you_do_not_receive: 'Jika Anda tidak menerima dana dalam waktu 15 menit, silakan hubungi tim bantuan kami.',
    payment_pending: 'Pembayaran <span class="text-cbs">tertunda</span>',
    payment_failed: 'Pembayaran <span class="text-cr">gagal</span>',
    payment_canceled: 'Pembayaran <span class="text-cg">dibatalkan</span>',
    payment_has_been_cancelled: 'Pembayaran telah dibatalkan seperti yang diminta',
    unfortunately_we_were_unable: 'Sayangnya kami tidak dapat memproses pembayaran Anda.',
    please_try_again: 'Silakan coba lagi',
    if_the_problem_persists: 'Jika masalah masih berlanjut, silakan hubungi tim bantuan kami. Anda juga bisa mencoba menggunakan metode pembayaran lain.',
    back_to_wallet: 'Kembali ke dompet',
    total_description: 'Dana yang berasal dari deposit dan penjualan Anda.',
    withdrawable_description: 'Hasil penjualan. Dana ini dapat ditarik atau digunakan untuk membeli barang.',
    locked_description: 'Dana yang dikunci sementara yang tidak dapat dibelanjakan atau ditarik. Alasan dana dikunci adalah karena adanya pesanan pembelian, pembelian barang, dll...',
    deposit_with_cryptocurrencies: 'Deposit dengan <span class="text-cp">mata uang kripto:</span>',
    deposit_with_standard_payment_methods: 'Deposit dengan <span class="text-cp">metode pembayaran standar:</span>',
    withdraw_with_cryptocurrencies: 'Tarik dengan <span class="text-cp">mata uang kripto:</span>',
    withdraw_with_standard_payment_methods: 'Tarik dengan <span class="text-cp">metode pembayaran standar:</span>',
    your_amount: 'Jumlah Anda',
    your_limit: 'Batas Anda',
    your_limits: 'Batas Anda',
    increase_your_limits: 'Tingkatkan limit Anda',
    payment_not_available_in_the_following_countries: 'Metode pembayaran ini tidak tersedia di negara-negara berikut:',
    the_price_is_updated_every_60_seconds: 'Harga diperbarui setiap 60 detik dan merupakan harga rata-rata yang dikumpulkan dari beberapa bursa.',
    rate_includes_x_fee: 'Harga sudah termasuk biaya {x}%.',
  },
  not_found: {
    title: 'Halaman tidak ditemukan',
    message: 'Sepertinya Anda tersesat. Anda dapat menemukan <br> skin impian Anda di halaman pasar.',
  },
  login: {
    welcome_to_bitskins: '<span class="text-cp">Selamat datang</span> di BitSkins',
    sign_in: 'Masuk',
    sign_up: 'Daftar',
    rules_text: 'Saya mengonfirmasi bahwa saya berusia 18 tahun atau lebih dan saya menyetujui persyaratan',
    sign_in_with_steam: 'Masuk dengan Steam',
    sign_up_with_steam: 'Daftar dengan Steam',
    email: 'Email',
    password: 'Kata sandi',
    already_have_an_account: 'Sudah memiliki akun? Klik',
    to_login: 'untuk masuk',
    to_login_via_email: 'untuk masuk melalui email',
    login_via_email: 'Masuk melalui Email',
    log_in_using_your_email: 'Masuk menggunakan alamat email dan kata sandi Anda.',
    forgot_password: 'Lupa kata sandi?',
    login_via_steam: 'MASUK MELALUI STEAM',
    register_first: 'Pertama, Anda harus mendaftar',
    passwords_not_migrated: 'Sayangnya, pada pembaruan terakhir kami tidak dapat memigrasi kata sandi Anda, oleh karena itu Anda perlu mengatur ulang kata sandi.',
  },
  common: {
    monthly: 'bulanan',
    x_to_y: '{x} ke {y}',
    minimum_x: 'Minimum {x}',
    maximum_x: 'Maksimum {x}',
    click: 'Klik',
    claim: 'Klaim',
    or: 'atau',
    and: 'dan',
    confirm: 'Konfirmasi',
    continue: 'Lanjutkan',
    cancel: 'Membatalkan',
    enable: 'Memungkinkan',
    enabled: 'diaktifkan',
    disable: 'Nonaktifkan',
    disabled: 'dinonaktifkan',
    download: 'Unduh',
    twofa: 'Autentikasi Dua Faktor',
    terms_of_use: 'Ketentuan Penggunaan',
    privacy_policy: 'Kebijakan Privasi',
    cookie_policy: 'Kebijakan Cookie',
    about_us: 'Tentang kami',
    changelog: 'Catatan perubahan',
    faq: 'PERTANYAAN YANG SERING DIAJUKAN',
    support: 'Dukungan',
    affiliate: 'Afiliasi',
    blog: 'Blog',
    careers: 'Karier',
    api: 'API',
    service_status: 'Status layanan',
    loading: 'Memuat...',
    buy_skins: 'Beli skin',
    sell_skins: 'Jual skin',
    popular: 'Populer',
    skin_categories: 'kategori skin',
    payments: 'Pembayaran',
    about_bitskins: 'Tentang BitSkins',
    social_media: 'Media sosial',
    follow_us: 'Ikuti kami dan bergabunglah dengan komunitas kami!',
    enter_your_email: 'Masukkan alamat email Anda',
    phone_number: 'Nomor telepon',
    verify: 'Verifikasi',
    add: 'Tambah',
    update: 'Perbarui',
    check_spam_folder: 'Jika Anda tidak dapat menemukan email tersebut di kotak masuk, silakan periksa folder spam.',
    here: 'di sini',
    edit: 'edit',
    save: 'simpan',
    copy: 'salin',
    back: 'Kembali',
    back_to_login: 'Kembali ke login',
    clear: 'Hapus',
    quantity: 'Jumlah',
    name: 'Nama',
    bot_name: 'Nama bot',
    steam: 'Steam',
    steam_id: 'ID Steam',
    steam_group: 'Kelompok steam',
    browser: 'Browser',
    on: 'Aktif',
    off: 'Mati',
    hidden: 'Tersembunyi',
    empty: 'Kosong',
    expires_in: 'Berakhir dalam',
    member_since: 'Anggota sejak',
    close: 'Tutup',
    paint_seed_value: 'Paint seed: {value}',
    error: 'Kesalahan',
    retry: 'Coba lagi',
    no_options_available: 'Tidak ada pilihan yang tersedia',
    search: 'Cari',
    any: 'Apa saja',
    min: 'Min',
    max: 'Maks',
    no_limit: 'Tidak ada batas',
    scroll_left: 'Gulir ke kiri',
    scroll_right: 'Gulir ke kanan',
    load: 'Memuat',
    delete: 'Menghapus',
    remove: 'Menghapus',
    all: 'Semua',
    game: 'Permainan',
    reset: 'Atur Ulang',
    in: 'dalam',
    optional: '(opsional)',
    default: 'Default',
    filter: 'Filter',
    up_to: 'Hingga',
    similar: 'Mirip',
    important: 'Penting',
    step: 'Langkah',
    share_link: 'Bagikan tautan',
    zoom: 'Memperbesar',
    found: 'Ditemukan',
    try_again: 'Coba lagi',
    of: 'dari',
    timer: 'Pengatur waktu',
    add_new: 'Tambahkan baru',
    and_more: 'DAN LEBIH BANYAK',
    check_status: 'Periksa status',
    resend_link: 'Kirim ulang tautan',
    back_to_home: 'Kembali ke halaman beranda',
    data_visible_only_to_logged_in_users: 'Data ini hanya dapat dilihat oleh pengguna yang masuk',
    login: 'Masuk',
    level: 'Level',
    twofa_code: 'Kode 2FA',
    id: 'ID',
    position: 'Posisi',
    amount: 'Jumlah',
    progressive_sum: 'Jumlah progresif',
    date: 'Tanggal',
    active: 'Aktif',
    yes: 'Ya',
    no: 'Tidak',
  },
  notifications: {
    change: 'Ubah',
    setup: 'Pengaturan',
    disconnect: 'Putuskan sambungan',
    connect: 'Menghubungkan',
    notifications: 'Pemberitahuan',
    notifications_center: 'Pusat notifikasi',
    clear_all: 'Menghapus semua notifikasi',
    notifications_channels: 'Saluran pemberitahuan',
    connected: 'Terhubung',
    all_notifications: 'Semua notifikasi',
    sound: 'Suara',
    volume_mute: 'Volume hening',
    volume_full: 'Volume penuh',
    all_sounds: 'Semua suara:',
    off: 'Mati',
    on: 'Hidup',
    steam_issues_title: 'Masalah Steam',
    steam_issues_content: 'Steam sedang mengalami masalah yang dapat memengaruhi pertukaran, sehingga menyebabkan pertukaran tidak dapat diproses atau dibuat.',
    name: {
      account_new_login: 'Login baru akun',
      inventory_sold: 'Inventaris terjual',
      inventory_buyorder: 'Pesanan pembelian inventaris',
      wallet_deposit_done: 'Setoran dompet selesai',
      support_new_reply: 'Dukungan balasan baru',
      support_ticket_closed: 'Tiket dukungan ditutup',
      inventory_bargain_received: 'Tawar-menawar inventaris diterima',
    },
  },
  market: {
    non_scraped_only: 'Hanya yang tidak tergores',
    set_price: 'Tetapkan harga',
    game_not_found: 'Game tidak ditemukan',
    game_not_available: 'Game saat ini tidak tersedia',
    any_stickers: 'Stiker apa saja',
    item_removed_from_sale: 'Item dihapus dari penjualan',
    price_updated: 'Harga diperbarui',
    item_withdrawn: 'Item ini telah ditarik',
    go_to_withdrawn: 'Pergi ke item yang ditarik',
    item_issue: 'Kami memiliki masalah dengan item ini',
    item_in_deposit_queue: 'Item ini ada dalam antrean setoran',
    item_in_withdraw_queue: 'Item ini ada dalam antrian penarikan',
    go_to_queued: 'Pergi ke item yang mengantri',
    item_in_bitskins_inventory: 'Item ini ada di inventaris BitSkins Anda',
    go_to_inventory: 'Pergi ke inventaris',
    go_to_issue: 'Pergi ke masalah',
    maximum_price: 'Harga maksimum',
    minimum_price: 'Harga minimum',
    average_price: 'Harga rata-rata',
    amount_sold: 'Jumlah yang terjual',
    withdrawal_batch_info: 'Perlu diketahui bahwa kami mengirimkan barang dalam beberapa kelompok setiap beberapa menit.',
    queued: 'Antrian',
    queued_description: 'Di sini Anda dapat menemukan item yang sedang dalam antrian untuk penarikan atau penyetoran.',
    withdrawn: 'Ditarik',
    withdrawn_description: 'Di sini Anda dapat menemukan item yang telah ditarik.',
    issues: 'Masalah',
    issues_description: 'Di sini Anda dapat menemukan item yang sedang mengalami masalah. Kami sedang berupaya menyelesaikan masalah ini.',
    max_items_selected: 'Anda tidak dapat memilih lebih dari {limit} item',
    item_status: 'Status barang',
    search_for_stickers: 'Mencari stiker',
    this_item: '(item ini)',
    no_items_found: {
      no_items_found: 'Tidak ada item yang ditemukan',
      no_items_found_span: 'Tidak ada item <span>ditemukan</span>',
      we_could_not_find_any_offers: 'Kami tidak dapat menemukan penawaran apa pun',
      for: ' untuk',
      this_can_be_due_to_applied_filters: 'Hal ini mungkin disebabkan oleh filter yang diterapkan. Anda bisa menghapus semua filter dengan mengeklik tombol di bawah ini',
    },
    only_tradable_items: 'Hanya item yang dapat dipertukarkan',
    not_accepting: 'Tidak menerima',
    sell: 'Jual',
    skin: 'Skin',
    items: 'item',
    items_v2: 'item',
    buy_orders: 'Beli pesanan',
    search_for: 'Mencari item {game}',
    search_for_items: 'Mencari item',
    reload: 'Muat ulang',
    item_name: 'Nama item',
    enter_item_name: 'Masukkan nama barang',
    price: 'Harga',
    reset: 'Atur ulang',
    all_items: 'Semua item',
    sort: 'Mengurutkan',
    add_sort: 'Tambahkan jenis',
    steam_price: 'Harga steam',
    reference_price: 'Harga referensi',
    steam_inventory: 'Persediaan Steam',
    your_steam_inventory: 'Persediaan Steam Anda',
    bitskins_inventory: 'Inventaris BitSkins',
    your_bs_inventory: 'Inventaris BitSkins Anda {extra}',
    refresh: 'Segarkan',
    learn_how_to_sell: 'Pelajari cara menjual',
    select_1_by_1: 'Pilih 1 per 1',
    select_all: 'Pilih semua',
    selected_items: 'Item yang dipilih',
    items_amount: '{count} barang',
    offers: 'penawaran',
    favorites: 'Favorit',
    last: 'Terakhir',
    viewed: 'dilihat',
    same_price: {
      same_price_for: 'Harga yang sama untuk',
      all_items: 'semua barang',
    },
    save_all: 'Simpan semua',
    trade_hold: {
      name: 'Penahanan perdagangan',
      between: 'Terkunci antara {min} dan {max} hari',
      less: 'Terkunci kurang dari {value} hari',
      any: 'Setiap penahanan perdagangan',
      none: 'Tidak ada penahanan perdagangan',
      withdrawable_in_days_hours: 'Dapat ditarik dalam {days} hari, {hours} jam',
      withdrawable_in_hours_minutes: 'Dapat ditarik dalam {hours} jam, {minutes} menit',
      tradable: 'Dapat dipertukarkan',
    },
    filter: {
      status: 'Status',
      date_from: 'Tanggal dari',
      date_to: 'Tanggal sampai',
      amount_from: 'Jumlah dari',
      amount_to: 'Jumlah dari',
      price_from: 'Harga dari',
      price_to: 'Harga sampai',
      service: 'Layanan',
      item: 'Barang',
      game: 'Permainan',
      type: 'Jenis',
      quality: 'Kualitas',
      exterior: 'Eksterior',
      category: 'Kategori',
      collection: 'Koleksi',
      color: 'Warna',
      family: 'Keluarga skin',
      phase: 'Fase',
      rarity: 'Kelangkaan',
      grade: 'Kelas',
      killstreak: 'Pukulan mematikan',
      effect: 'Efek',
      hero: 'Pahlawan',
      nametag: 'Tag Nama',
      hightier: 'Tingkat Tinggi',
      stickers: 'Stiker',
      slot: 'Slot {value}',
      paint_seed: 'Paint seed',
      paint_index: 'Paint index',
      sticker_counter: 'Jumlah stiker',
      float_value: 'Float',
      active: '{value} aktif',
      by_slot_position: 'Berdasarkan posisi slot',
      filter_name: 'Filter nama',
      you_can_have: 'Anda dapat memiliki',
      filters_saved: 'filter yang disimpan.',
      choose_stickers: 'Memilih stiker',
      no_stickers_found: 'Tidak ada stiker yang ditemukan',
      basic_filters: 'Filter Dasar',
      advanced_filters: 'Filter Tingkat Lanjut',
      clear_all_filters: 'Menghapus semua filter',
      save_filters: 'Menyimpan filter',
      my_filters: 'Filter saya',
      filters_are_not_available_on_this_page: 'Filter tidak tersedia di halaman ini',
    },
    loading_item: 'Memuat item',
    bestseller: 'Terlaris',
    this_is_your_item: 'Ini adalah barang Anda',
    action: {
      screenshot: 'Tangkapan layar',
      inspect: 'Memeriksa dalam game',
      view_at_steam: 'Lihat di Steam',
      check_on_steam_market: 'Periksa di pasar Steam',
      share: 'Bagikan',
      sell_instantly: 'Jual secara instan',
      buy: 'Beli',
      remove_from_sale: 'Hapus dari penjualan',
      check_on_market: 'Periksa di pasar',
      item_page: 'Halaman barang',
      bulk_buy: 'Pembelian massal',
      add_to_favorites: 'Tambahkan ke favorit',
      remove_from_favorites: 'Hapus dari favorit',
      buy_now: 'Beli sekarang',
      bump: 'Benturan',
      sticker: 'Item dengan stiker ini',
    },
    bump_minimum: 'Bump hanya tersedia untuk item yang bernilai lebih dari {amount}',
    your_price: 'Harga Anda',
    cart: {
      add_to_cart: 'Tambahkan ke troli',
      remove_from_cart: 'Hapus dari troli',
      add_stickers_to_cart: 'Tambahkan stiker ke keranjang',
      remove: 'Hapus',
      in_cart: 'Di troli',
    },
    details: 'Detail',
    tags: 'Tag',
    do_you_want_rename: 'Apakah Anda ingin mengganti nama item Anda?',
    currently_not_available: 'Saat ini tidak tersedia',
    nametag: 'Label Nama',
    sales: 'Penjualan',
    private_offer: 'Penawaran pribadi',
    private_offers: 'Penawaran pribadi',
    private_offers_description: 'Anda memiliki {counter} penawaran pribadi. Anda dapat menemukannya',
    public_offer: 'Penawaran publik',
    offer_visible_only_to_people_with_link: 'Penawaran ini hanya dapat dilihat oleh orang-orang yang memiliki tautan ke penawaran tersebut',
    checkout: {
      if_any: 'Jika salah satu item di keranjang Anda tidak lagi tersedia, item tersebut tidak akan ditambahkan ke pesanan Anda.',
      remove_all_items: 'Hapus semua item',
      order_summary: 'Ringkasan pesanan',
      you_will_save: 'Anda akan menghemat',
      i_have_read: 'Saya telah membaca dan menyetujui Ketentuan Layanan dan Kebijakan Privasi dan saya memahami bahwa semua pembelian bersifat final dan tidak dapat dikembalikan.',
      confirm_checkout: 'Konfirmasi pembayaran',
      you_need_to_deposit_at_least_x: 'Anda harus menyetor setidaknya {amount} untuk membeli barang di keranjang Anda.',
      you_cannot_complete: 'Anda tidak dapat menyelesaikan pesanan Anda karena Anda tidak memiliki cukup dana di akun Anda. Anda harus melakukan deposit minimal {amount} untuk membeli item di ',
      these_items_will_be_removed: 'Barang-barang ini akan dihapus dari daftar setelah pembayaran.',
      this_item_will_not_be_included: 'Item ini tidak akan disertakan dalam pesanan Anda',
      need_tos_accept: 'Anda harus menyetujui Ketentuan Layanan dan Kebijakan Privasi',
      no_items_selected: 'Tidak ada item yang dipilih',
    },
    deposit_status: {
      available: 'Tersedia',
      missing: 'Hilang',
      not_accepting: 'Tidak menerima',
      wrong_price: 'Harga salah',
      already_queue: 'Sudah dalam antrian',
      locked: 'Terkunci',
    },
    withdraw_progress: {
      status: 'Status penarikan',
      selected: 'Dipilih',
      waiting: 'Menunggu',
      in_queue: 'Dalam antrian',
      trade_link: 'Tautan perdagangan',
      done: 'Selesai',
      error: 'Kesalahan',
      failed: 'Gagal',
      pending: 'Tertunda',
    },
    trade_state: {
      Invalid: 'Tidak valid',
      Active: 'Aktif',
      Accepted: 'Diterima',
      Countered: 'Ditolak',
      Expired: 'Kadaluarsa',
      Canceled: 'Dibatalkan',
      Declined: 'Ditolak',
      InvalidItems: 'Item tidak valid',
      CreatedNeedsConfirmation: 'Dibuat, perlu konfirmasi',
      CanceledBySecondFactor: 'Dibatalkan oleh faktor kedua',
      InEscrow: 'Dalam escrow',
    },
    trade_type: {
      deposit: 'Menyetor',
      withdraw: 'Penarikan',
      bidirectional: 'Dua arah',
    },
    inventory: {
      history: 'Sejarah',
      active_trades: 'Perdagangan aktif',
      loading_your_inventory: 'Memuat inventaris Anda',
      lower_sale_fee: '{value}% biaya penjualan lebih rendah',
      group_diff_price: 'Tidak semua item dalam grup memiliki harga yang sama',
      group_diff_delist: 'Tidak semua item dalam grup ditandai untuk dihapus',
      delist: 'Hapus',
      this_may_take_a_while: 'Ini mungkin membutuhkan waktu beberapa saat',
      relist_items: 'Daftar ulang item',
      cancel_relisting: 'Membatalkan daftar ulang',
      cancel_withdrawal: 'Batalkan penarikan',
      withdraw_items: 'Menarik item',
      cancel_editing: 'Membatalkan pengeditan',
      edit_items: 'Mengedit item',
      sell_items: 'Menjual item',
      steam_offers: 'Penawaran steam',
      clear_withdraw_items: 'Menghapus item',
      loading_inventory: 'Memuat inventaris',
      update_x_items: 'Memperbarui item {amount}',
      delist_x_items: 'Menghapus item {amount}',
    },
    message: {
      failed_to_create_trade_offer: 'Gagal membuat penawaran pertukaran',
      offer: 'Menawarkan {hash}',
      offer_failed: 'Penawaran gagal (dengan status {state})',
      offer_confirmed: 'Penawaran Anda telah dikonfirmasi dan Anda telah berhasil mendaftarkan item untuk dijual',
      offer_sent: 'Penawaran pertukaran Anda telah dikirim',
      open_trade: 'Buka penawaran pertukaran',
      withdraw: 'Tarik penawaran {hash}',
      withdraw_confirmed: 'Penarikan Anda telah diterima',
      offer_preparing: 'Jual beli Anda sedang disiapkan. Kami akan segera mengirimkan penawaran kepada Anda',
      offer_active: 'Jual beli Anda sudah siap. Terima di sini',
      offer_needs_confirmation: 'Konfirmasi pertukaran di aplikasi seluler',
    },
    deposit_type: {
      public: 'Publik',
      public_description: 'Barang Anda akan terlihat oleh semua pengguna BitSkins. Ini adalah opsi penjualan yang paling populer.',
      private: 'Pribadi',
      private_description: 'Barang Anda hanya akan terlihat oleh orang-orang yang memiliki tautan ke barang tersebut. Penjualan pribadi 50% lebih murah daripada penjualan standar.',
      instant_sell: 'Jual instan',
      instant_description: 'Setelah mengirim barang ke bot kami, uang akan segera dikreditkan ke akun Anda.',
    },
    click_to_open: 'Klik untuk membuka tautan di tab baru',
    no_active_trades: 'Tidak ada pertukaran aktif',
    go_to_all_trades: 'Pergi ke semua pertukaran',
    update_trade_link: 'Perbarui tautan pertukaran',
    withdraw: 'Menarik diri',
    lowest_price: 'Harga terendah:',
    no_filters_available: 'Tidak ada filter yang tersedia',
    select_a_hero: 'Pilih seorang pahlawan:',
    view_all_items: 'Lihat semua item',
    stattrak: 'StatTrak™',
    item_not_available: 'Item ini tidak lagi tersedia',
    out_of_stock: 'Kehabisan stok',
    find_similar_item: 'Temukan barang serupa',
    find_similar_items: 'Temukan barang serupa',
    sell_for: 'Jual untuk',
    recommended: 'Direkomendasikan',
    price_discounted: 'Harga diskon',
    price_average: 'Harga rata-rata (disarankan)',
    price_expensive: 'Harga tinggi',
    sticker: 'stiker',
    more: 'Lainnya',
    recent: 'Terbaru',
    item_not_found: 'Barang tidak ditemukan',
    for: 'untuk',
    you_will_pay: 'Anda akan membayar',
    fade: 'Memudar: {value}%',
    see_all_items: 'Lihat semua item {amount}',
    it_my_take_a_while: 'Ini mungkin membutuhkan waktu beberapa saat',
    no_transactions_found: 'Tidak ada transaksi yang ditemukan',
    item: 'Barang',
    edit: 'Edit',
    add_items_to_edit: 'Menambahkan item untuk diedit',
    add_items_to_delist: 'Menambahkan item untuk dihapus',
    add_items_to_sale: 'Menambahkan item untuk dijual',
    add_items_to_withdraw: 'Menambahkan item untuk ditarik',
    group_by_name: 'Mengelompokkan berdasarkan nama',
    select_items_from_your_inventory: 'Memilih item dari inventaris Anda',
    earnings: 'Penghasilan',
    total_fee: 'Total biaya',
    total_amount: 'Jumlah total',
    confirm_purchase: 'Konfirmasi <span class="text-cp">pembelian</span>',
    thank_you_for_shopping_with_us: '<span class="text-cp">Terima kasih</span> telah berbelanja bersama kami!',
    you_have_purchased_x_items_for: 'Anda telah membeli <span class="text-cp">{x}</span> item untuk',
    you_have_purchased_x_for: 'Anda telah membeli <span class="text-cp">{x}</span> untuk',
    total: 'Total',
    you_saved: 'Anda menyimpan',
    see_your_inventory: 'Lihat inventaris Anda',
    you_bought: 'Anda membeli',
    order_details: 'Detail pesanan',
    items_not_available: 'Sayangnya, beberapa item dari keranjang Anda tidak tersedia, sehingga Anda tidak dapat membelinya. Di bawah ini Anda dapat menemukan daftar item tersebut.',
    total_price: 'Total harga',
    withdraw_all_items: 'Tarik semua barang',
    private_listing: 'Daftar pribadi {extra}',
    public_listing: 'Daftar publik {extra}',
    instant_sale_price: 'Harga jual instan',
    not_accepted: 'Tidak diterima',
    not_available: 'Tidak tersedia',
    no_sales_data: 'Tidak ada data penjualan',
    create_buy_order: 'Buat pesanan beli',
    active_buy_orders: 'Pesanan beli aktif Anda',
    buy_orders_history: 'Riwayat pesanan beli',
    market_buy_orders: 'Pesanan beli pasar',
    recent_sales: 'Penjualan terbaru',
    selling_price: 'Harga jual',
    sales_chart: 'Grafik penjualan',
    sales_history_will_be_available_soon: 'Riwayat penjualan BitSkins dan Steam akan segera tersedia',
    souvenir: 'Suvenir',
    under: '{amount} ke bawah',
    above: '{amount} ke atas',
    amount_to_amount: 'dari {amount1} hingga {amount2}',
    discount: 'Diskon',
    value_off_or_more: 'Diskon {value}% atau lebih',
    removed_items: 'Item yang dihapus',
    restore_all_items: 'Mengembalikan semua item',
    add_x_items_to_edit: 'Menambahkan {amount} item untuk diedit',
    add_x_items_to_sale: 'Menambahkan {amount} item untuk dijual',
    add_x_items_to_withdraw: 'Menambahkan {amount} item untuk ditarik',
    sell_x_items: 'Menjual {amount} item',
    withdraw_x_items: 'Menarik {amount} item',
    first_you_need_to_select_an_item: 'Pertama, Anda harus memilih item.',
    cheapest_price_on_bitskins: 'Harga termurah di BitSkins:',
    final_price: 'Harga akhir:',
    check_quantity: 'Periksa kuantitas',
    cancel_selected_orders: 'Membatalkan pesanan yang dipilih',
    cancel_all_orders: 'Batalkan semua pesanan',
    community_rating: 'Peringkat komunitas:',
    rating: 'Peringkat',
    votes: 'suara',
    open_image: 'Buka gambar',
    cheaper_than_steam_by_x: 'Lebih murah dari Steam oleh {x}%',
    there_are_other_items_you_may_like: '<span>Ada item lain</span> yang mungkin Anda sukai...',
    available_variants: 'Varian yang tersedia',
    picture: {
      playside: 'Sisi bermain',
      backside: 'Bagian belakang',
      steam: 'Gambar pasar steam',
    },
    buy_orders_not_available: 'Pesanan beli saat ini tidak tersedia',
    confirm_price_change: 'Konfirmasi perubahan harga',
    are_you_sure_to_change_price: 'Apakah Anda yakin ingin mengubah harga menjadi <span class="text-cp fw-sb">{price}</span>?',
  },
  bumps: {
    heading: 'Apakah Anda ingin <span class="text-cp">menjual barang Anda lebih cepat </span> tanpa menurunkan harganya?',
    subheading: 'Kami punya sesuatu untuk Anda!',
    how_it_works: 'Bagaimana cara kerjanya?',
    description: 'Di BitSkins kami memiliki opsi bumping yang memungkinkan Anda untuk menampilkan item Anda di halaman pasar dan di beberapa tempat lain di situs web. Ini adalah solusi yang sempurna untuk seseorang yang ingin mempercepat proses penjualan barang tanpa harus menurunkan harganya. Ketika Anda menabrak item, lebih banyak orang akan melihatnya dan peluang untuk menjualnya meningkat. Anda dapat mulai melakukan bumps mulai dari $0.75 atau bahkan kurang dari itu (silakan periksa paket bumps kami).',
    your_active_x_autobumps: 'Bump {x} otomatis Anda',
    bumps_packages: 'Paket bumps',
    bumps: 'bumps',
    bumps_title: 'Bumps',
    available_bumps: 'Bumps yang tersedia',
    buy_selected_package: 'Beli paket yang dipilih',
    when_you_bump: 'Ketika Anda menabrak sebuah item, item tersebut akan ditampilkan di tempat-tempat berikut ini:',
    step_1_title: 'Di halaman pasar di bagian <span class="text-cp">bar bagian atas</span>',
    step_2_title: 'Pada halaman pasar di <span class="text-cp">bagian utama</span>',
    step_2_text: '(Hanya jika opsi pengurutan diatur ke "unggulan". Ini adalah opsi default).',
    step_3_title: 'Pada <span class="text-cp">halaman beranda</span>',
    step_4_title: 'Pada halaman item di bagian <span class="text-cp">item serupa</span>',
    step_5_title: 'Pada bagian <span class="text-cp">item yang disarankan</span>',
    after_bumping: '<span class="text-cp">Setelah bump</span> sebuah item, item tersebut akan ditampilkan <span class="text-cp">pertama kali </span>di setiap bagian. Namun, <span class="text-cp">jika ada orang lain yang menabrak item mereka setelah Anda </span> maka item Anda akan dipindahkan ke <span class="text-cp">posisi kedua </span>. Item Anda akan terlihat di setiap bagian selama tidak ada cukup banyak bump yang akan mendorongnya keluar dari bagian tersebut.',
    how_to_bump: '<span class="text-cp">Bagaimana cara</span> bump item saya?',
    how_to_1: 'Buka menu item',
    how_to_2: 'Pilih opsi <span class="text-cp">bump</span>',
    how_to_3: 'Pilih jenis bump',
    how_to_4: 'Selesai!',
    table: {
      item: 'Item',
      quantity: 'Jumlah',
      left: 'Kiri',
      period: 'Periode',
      created_at: 'Dibuat pada',
      updated_at: 'Diperbarui pada',
      next_bump_at: 'bump berikutnya di',
      action: 'Tindakan',
      status: 'Status',
    },
    auto_enabled: 'Bump otomatis diaktifkan',
    auto_disabled: 'Bump otomatis dibatalkan',
    single_bumped: 'Item telah dibatalkan!',
  },
  buy_order: {
    confirm_buy_orders_cancellation: 'Konfirmasi <span class="color-primary">pembatalan pesanan</span> pembelian',
    are_you_sure_that_you_want_to_cancel: 'Apakah Anda yakin ingin membatalkan semua pesanan beli Anda?',
    create_buy_order: 'Buat <span class="text-cp">beli pesanan</span>',
    predict_place_in_queue: 'Memprediksi tempat dalam antrian',
    your_place_in_the_queue: 'Tempat Anda dalam antrian:',
    may_purchase_items_with_trade_hold: 'Pesanan beli dapat membeli item dengan penahanan perdagangan.',
    create_a_buy_order_for_this_item: 'Buat pesanan beli untuk item ini',
    no_buy_orders_found: 'Tidak ada pesanan beli yang ditemukan',
    position_in_queue: 'Posisi dalam antrian',
    this_is_your_buy_order: '(ini adalah pesanan beli Anda)',
    skin_name: 'Nama skin:',
    offers_on_market: 'penawaran di pasar',
  },
  instant_sell: {
    confirmation: 'Konfirmasi jual instan',
    you_can_sell_x: 'Anda bisa menjual AWP | Asiimov (Teruji di Lapangan) secara instan dan menerima $10.',
    the_funds_will_be_credited: 'Dana akan segera dikreditkan ke akun Anda. Jika Anda ingin melanjutkan, klik "Jual langsung";',
  },
  sort: {
    select_option: 'Pilih opsi',
    apply: 'Terapkan',
    clear: 'Hapus',
    default_order_placeholder: 'Pilih opsi',
    select_order_placeholder: 'Pilih jenis',
    default_sort: 'Pengurutan default',
    custom_sort: 'Pengurutan khusus',
    field: {
      price: 'Harga',
      discount: 'Diskon',
      id: 'Tanggal ditambahkan',
      bumped_at: 'Unggulan',
      suggested_price: 'Harga yang disarankan',
      asset_id: 'Tanggal ditambahkan',
      float_value: 'Mengapung',
      paint_index: 'Paint index',
      paint_seed: 'Paint seed',
      extras_1: 'Nilai ekstra',
      extras_1_fade: 'Memudar',
      amount: 'Jumlah',
      name: 'Nama',
    },
    order: {
      price: {
        asc: 'Termurah pertama',
        desc: 'Mahal pertama',
      },
      discount: {
        desc: 'Tertinggi pertama',
      },
      id: {
        asc: 'Tertua pertama',
        desc: 'Terbaru pertama',
      },
      asset_id: {
        asc: 'Tertua pertama',
        desc: 'Terbaru pertama',
      },
      bumped_at: {
        desc: 'Default',
        asc: '',
      },
      default: {
        asc: 'Terendah pertama',
        desc: 'Tertinggi pertama',
      },
    },
  },
  pagination: {
    showing: 'menunjukkan',
    to: 'ke',
    of: 'dari',
    records: 'catatan',
  },
  popups: {
    click_confirmation_link: 'Silakan periksa kotak masuk email Anda dan klik tautan konfirmasi untuk menyelesaikan prosesnya.',
    steam_login_issue: {
      title: 'Masalah login Steam',
      an_error_occured: 'Terjadi kesalahan saat mencoba masuk melalui Steam. Silakan coba lagi.',
    },
    steam_inventory_private: {
      title: 'Inventaris Steam Anda adalah <span class="text-cp">private</span>',
      we_were: 'Kami tidak dapat memuat inventaris Steam Anda. Silakan ubah status inventaris Anda menjadi publik.',
      you_can: 'Anda dapat melakukannya di pengaturan Steam. Ingatlah bahwa mungkin diperlukan waktu hingga beberapa menit sebelum kami mendeteksi perubahannya.',
      steam_settings: 'Pengaturan Steam',
    },
    account_deletion_in_progress: {
      title: 'Penghapusan akun sedang berlangsung...',
      process_started: 'Anda telah memulai proses penghapusan akun.',
      account_will_be_deleted: 'Akun Anda akan dihapus pada saat',
      cancel_deletion: 'Batalkan penghapusan',
      confirm_deletion: 'Konfirmasi penghapusan',
      check_your_email: 'Periksa email Anda',
    },
    account_deletion_confirm: {
      title: 'Konfirmasi penghapusan akun',
      subtitle: 'Apakah Anda yakin ingin menghapus akun Anda?',
      once_you_confirm: 'Setelah Anda mengonfirmasi, Anda akan secara otomatis keluar dan semua data akun Anda akan dihapus secara permanen setelah dua minggu. Selama dua minggu tersebut, Anda dapat membatalkan proses penghapusan dengan masuk ke akun Anda.',
      once_your_account_is: 'Setelah akun Anda dihapus, Anda dapat membuat akun BitSkins baru dengan masuk ke situs web.',
      however_you_will_not: 'Namun, Anda tidak akan memiliki akses ke data yang telah dihapus.',
      if_you_want_to_continue: 'Jika Anda ingin melanjutkan, klik konfirmasi dan klik tautan konfirmasi di email yang kami kirimkan kepada Anda.',
      login: 'Anda harus masuk untuk mengonfirmasi penghapusan akun',
      canceled: 'Penghapusan akun telah dibatalkan',
      confirmed: 'Penghapusan akun telah dikonfirmasi',
    },
    account_deletion_check_your_email: {
      title: 'Periksa email Anda',
      to_complete: 'Untuk menyelesaikan proses penghapusan akun, klik tautan konfirmasi di email yang kami kirimkan kepada Anda.',
    },
    twofa_enable: {
      already_done: 'Anda telah mengaktifkan 2FA.',
      setup_email_before: 'Untuk mengaktifkan 2FA, Anda perlu menyiapkan email terlebih dahulu.',
      twofa_authentication_adds: 'Autentikasi dua faktor (2FA) menambahkan lapisan keamanan ekstra pada akun Anda dengan membutuhkan dua metode (faktor) untuk memverifikasi identitas Anda. Mengaktifkan 2FA sangat disarankan untuk menjaga keamanan akun Anda, karena mencegah login yang tidak diinginkan tanpa akses ke kode 2FA tambahan.',
      setup_twofa: 'Menyiapkan autentikasi dua faktor',
      if_you_dont_have_an_authenticator_app: 'Jika Anda <span class="text-cp">tidak memiliki </span> aplikasi pengautentikasi',
      we_recommend: '<p>Kami merekomendasikan <a href="https://support.google.com/accounts/answer/1066447?hl=en" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Google Authenticator</a> atau <a href="https://authy.com/download/" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Authy</a> untuk pengguna Android dan iOS. Jika Anda ingin menggunakan aplikasi ini di komputer Anda, Anda dapat mengunduh dan memasang <a href="https://authy.com/download/" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Authy</a> atau gunakan<a href="https://chrome.google.com/webstore/detail/authenticator/bhghoamapcdpbohphigoooaddinpkbai" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Ekstensi Google Authenticator</a> di peramban Anda.',
      scan_the_qr_code: 'Pindai kode QR <span class="text-cp">Pindai</span> kode QR',
      open_your_authenticator_app: 'Buka aplikasi pengautentikasi Anda dan pindai kode QR atau masukkan kunci rahasia secara manual.',
      secret_key: 'Kunci rahasia',
      this_secret_key_will_be_valid_for_x_seconds: 'Kunci rahasia ini akan berlaku untuk <span class="text-cp">{x} @:{\'time.seconds\'}</span>.',
      save_this_secret: 'Simpan kunci rahasia ini di tempat yang aman. Kunci ini akan memungkinkan Anda untuk mendapatkan kembali akses ke kode 2FA Anda ketika Anda kehilangan akses ke aplikasi autentikator.',
      enter_the_6_digit_code: 'Masukkan <span class="text-cp">kode 6 digit</span> yang dihasilkan oleh aplikasi autentikator Anda',
      enter_code_from_the_email: 'Masukkan kode dari <span class="text-cp">email</span>',
      enter_the_verification_code: 'Masukkan kode verifikasi yang kami kirimkan ke <span class="text-cp">{email}</span>.',
      desktop: 'Desktop',
    },
    twofa_enabled: {
      now_your_account_is: 'Kini akun Anda dilindungi oleh autentikasi dua faktor.',
      all_future_logins: 'Semua login di masa mendatang akan mengharuskan Anda memasukkan kode yang diberikan oleh aplikasi autentikator Anda.',
    },
    twofa_enter_code: 'Masukkan kode 2FA yang dihasilkan oleh aplikasi pengautentikasi Anda.',
    twofa_disable: {
      title: 'Menonaktifkan Autentikasi Dua Faktor',
      enter_the_6_digit_code: 'Masukkan kode 6 digit yang dihasilkan oleh aplikasi autentikasi Anda.',
      cannot_access: 'Tidak dapat mengakses kode verifikasi Anda? Silakan hubungi kami di',
    },
    twofa_disabled: 'Akun Anda tidak lagi dilindungi oleh autentikasi dua faktor.',
    order_unable_to_process: {
      title: 'Kami tidak dapat <span class="text-cr">memproses pesanan Anda </span>',
      an_error_occurred: 'Terjadi kesalahan saat memproses pesanan Anda.<br> Silakan kembali ke halaman checkout dan coba lakukan pemesanan lagi.',
      back_to_checkout: 'Kembali ke pembayaran',
      back_to_item: 'Kembali ke item',
      information: 'Jika kesalahan ini sering terjadi, Anda harus menghubungi kami melalui tautan <a rel="nofollow noopener noreferrer" target="_blank" href="https://bitskins.com/support" class="text-cp">halaman dukungan</a> dengan menyertakan kode kesalahan:',
    },
    phone_number_add: {
      title: 'Tambahkan nomor telepon Anda',
      to_continue: 'Untuk melanjutkan, Anda harus menambahkan nomor telepon ke akun Anda terlebih dahulu.',
      add_number: 'Tambahkan nomor',
    },
    phone_number_confirmed: {
      title: 'Nomor telepon dikonfirmasi',
      your_phone_number: 'Nomor telepon Anda telah dikonfirmasi.',
    },
    phone_number_verify: {
      title: 'Verifikasi nomor telepon Anda',
      to_verify: 'Untuk memverifikasi nomor telepon Anda, Anda harus memasukkan kode verifikasi yang kami kirimkan ke',
      enter_sms_code: 'Masukkan kode SMS',
      you_cannot_update: 'Anda tidak dapat memperbarui nomor telepon Anda pada tahap ini. Anda akan dapat melakukannya dalam {minutes} menit.',
    },
    phone_number_verification_in_progress: {
      title: 'Verifikasi nomor telepon sedang berlangsung',
      if_you_wish: 'Jika mau, Anda dapat memperbarui nomor telepon atau mengirim ulang kode verifikasi.',
      send_code: 'Kirim kode',
    },
    email_address_add: {
      your_email_address: 'alamat email Anda',
      by_providing_my_email: 'Dengan memberikan alamat email saya, saya setuju untuk menerima komunikasi pemasaran',
      verification_in_progress: 'Verifikasi email sedang berlangsung',
      to_verify: 'Untuk memverifikasi alamat email Anda, Anda harus mengklik tautan konfirmasi dalam email yang kami kirimkan ke',
      if_you_wish: 'Jika Anda ingin, Anda dapat memperbarui alamat email Anda atau mengirim ulang tautan aktivasi.',
    },
    email_address_verify: {
      we_are_verifying: 'Kami sedang memverifikasi alamat email Anda dan mungkin memerlukan waktu beberapa saat...',
      confirmed: 'Alamat email Anda telah dikonfirmasi.',
    },
    email_address_confirmed: {
      title: 'Alamat email telah dikonfirmasi',
      your_email_address: 'Alamat email Anda telah dikonfirmasi.',
    },
    enter_your_trade_url: {
      title: 'Masukkan <span class="text-cp">url perdagangan</span>',
      to_continue: 'Untuk melanjutkan, Anda harus menyiapkan url pertukaran Anda terlebih dahulu. Anda akan menemukannya',
      your_trade_url: 'URL pertukaran Anda',
    },
    password_reset_enter_email: {
      forgot: 'Lupa kata sandi Anda',
      password: 'kata sandi Anda?',
      dont_worry: 'Jangan khawatir, masukkan alamat email Anda di bawah ini.',
      we_will_send: 'Kami akan mengirimkan tautan untuk mengatur ulang kata sandi Anda.',
      send_reset_link: 'Kirim tautan pengaturan ulang',
      if_this_email: 'Jika alamat email ini terkait dengan akun BitSkins,',
      you_will_receive: 'Anda akan menerima email berisi tautan untuk mengatur ulang kata sandi Anda.',
    },
    password_reset_new_password: {
      enter_your: 'Masukkan kata sandi Anda',
      new_password: 'kata sandi baru Anda',
      enter_password: 'Masukkan kata sandi',
      repeat_password: 'Ulangi kata sandi',
      save_password: 'Simpan kata sandi',
    },
    link_expired: {
      title: 'Tautan kedaluwarsa',
      the_process_cannot: 'Proses ini tidak dapat diselesaikan. Tautan telah kedaluwarsa.',
      go_to_settings: 'Pergi ke pengaturan',
    },
    wrong_link: {
      title: 'Tautan salah',
      we_were_unable: 'Kami tidak dapat memproses permintaan Anda. Anda telah mengikuti tautan yang salah.',
    },
    trade_preparing: {
      title: 'Kami sedang menyiapkan penawaran pertukaran Anda',
      processing: 'Mungkin perlu beberapa detik...',
    },
    trade_sent: {
      trade_offer_has_been_sent: 'Penawaran pertukaran Anda telah <span class="text-cp">telah dikirim</span>',
    },
    trade_done: {
      title: 'Penawaran pertukaran telah <span class="text-cp">diterima</span>',
      listed: 'Anda telah berhasil mendaftarkan barang untuk dijual. Anda dapat mengelolanya di bagian <a rel="nofollow noopener noreferrer" href="https://bitskins.com/selling" class="text-cp">tab penjualan</a>.',
      see_listed: 'Lihat barang yang Anda daftarkan',
      withdrawn: 'Anda telah berhasil menarik barang Anda.',
    },
    trade_declined: {
      your_trade_offer_has_been: 'Penawaran pertukaran Anda telah',
      declined: 'ditolak',
      if_you: 'Jika Anda tidak menolaknya sendiri, itu berarti ada orang yang menggunakan akun Anda dan barang Anda mungkin berisiko dicuri.',
      to_stay: 'Untuk melindungi item Anda, Anda harus bertindak cepat dan mengikuti langkah-langkah berikut:',
      step_revoke: 'Cabut API Key Web Steam Anda.',
      step_revoke_btn: 'CABUT KEMBALI KUNCI API',
      step_password: 'Ubah kata sandi Steam Anda.',
      step_password_btn: 'UBAH KATA SANDI',
      step_deauth: 'Batalkan otorisasi semua perangkat di Steam.',
      step_deauth_btn: 'BATALKAN OTORISASI PERANGKAT',
      step_trade: 'Buat URL pertukaran Steam baru.',
      step_trade_btn: 'BUAT URL PERDAGANGAN BARU',
      step_new: 'Tetapkan tautan pertukaran baru Anda di BitSkins.',
      step_new_btn: 'SETEL URL JUAL BELI BARU',
      step_try: 'Coba setorkan item Anda lagi dan lihat apakah masalahnya masih ada.',
      step_try_if: 'Jika terus terjadi, hentikan semua pertukaran dan hubungi tim bantuan kami.',
      contact_support: 'Hubungi dukungan',
      information: 'Ingatlah bahwa anggota staf dan bot kami tidak akan pernah meminta setoran apa pun melalui Steam Chat, Discord, atau di mana pun - siapa pun yang mengaku sebagai admin, dll.. adalah palsu dan kemungkinan besar ingin menipu Anda. Tetap aman!',
    },
    trade_failed: {
      offer_failed_title: 'Penawaran pertukaran <span class="text-cr">gagal</span>',
      offer_failed_text: 'Sayangnya, penawaran pertukaran Anda gagal. Silakan coba lagi.',
      offer_failed_to_create_title: '<span class="text-cr">Gagal membuat</span> penawaran pertukaran',
      offer_failed_to_create_text: 'Sayangnya, kami tidak dapat membuat penawaran pertukaran Anda. Silakan coba lagi.',
      contact_support: 'Jika kesalahan ini sering terjadi, Anda harus menghubungi kami melalui tautan <a rel="nofollow noopener noreferrer" target="_blank" href="https://bitskins.com/support" class="text-cp">halaman dukungan</a>.',
      support_page: 'halaman dukungan',
      cannot_process: 'Kami tidak dapat memproses penawaran pertukaran Anda',
      unfortunately_we_were_unable: 'Sayangnya, kami tidak dapat memproses penawaran pertukaran Anda. Kemungkinan besar Anda sudah memiliki penawaran pertukaran aktif untuk item tersebut.',
    },
    items_not_available: {
      title: 'Item tidak lagi tersedia untuk dijual',
      unfortunately: 'Sayangnya, item dari keranjang Anda sudah tidak lagi tersedia untuk dijual.',
      dont_worry: 'Jangan khawatir, Anda dapat menemukan banyak barang di halaman pasar.',
      unavailable_items: 'Barang tidak tersedia',
      back_to_market: 'Kembali ke pasar',
    },
    bump_purchase_confirmation: {
      title: 'Konfirmasi pembelian',
      do_you_want_to_purchase: 'Apakah Anda ingin membeli <span class="text-cp">{quantity} bumps</span> untuk <span class="text-cp">{price}</span>?',
      bumps_package: 'paket bump',
    },
    bump_start: {
      title: 'Bump item Anda',
      bump_your_item: 'Bump item Anda untuk menampilkannya di halaman pasar dan di beberapa tempat lain di situs web.<br> Ini dapat membantu Anda menjual item Anda lebih cepat karena akan diperhatikan oleh lebih banyak orang.<br> Jika Anda ingin mempelajari lebih lanjut tentang cara kerja fitur bumping',
      click_here: 'klik di sini',
      single_bump: 'bump tunggal',
      autobumps: 'Bump otomatis',
      one_bump: '1 kali Bump',
      this_option_single_bump: 'Opsi ini hanya akan membenturkan item Anda sekali saja dan biayanya adalah <span class="text-cp">$ 0,75</span>. Jika Anda sudah memiliki bump yang tersedia di akun Anda, maka tidak ada yang akan dibebankan dari saldo Anda.',
      this_option_autobumps: 'Opsi ini akan menambah item Anda setiap periode waktu yang dipilih. Jika Anda sudah memiliki bumps yang tersedia di akun Anda, maka tidak ada yang akan dikenakan biaya dari saldo Anda. Jika Anda kehabisan bumps, maka <span class="text-cp">$0.75</span> akan dikurangkan dari saldo Anda pada setiap bumps. Anda dapat membeli lebih banyak bump di muka <span class="text-cp">Anda dapat membeli lebih banyak bump di muka </span> dan di saat yang sama <span class="text-cp">menghemat uang </span> - gulir ke bawah untuk melihat paket-paket bump.',
      bump_every: 'Bump setiap',
      bumps_amount: 'Jumlah benturan',
      delayed_start: 'Awal yang tertunda',
      delayed_start_description: 'Dengan mencentang opsi ini, bump pertama Anda akan ditunda selama periode waktu yang dipilih.',
    },
    bump_stop: {
      title: 'Hentikan bump otomatis',
      do_you_want: 'Apakah Anda ingin menghentikan bump otomatis untuk item ini?',
    },
    bulk_buy: {
      bulk_buy: '<span class="text-cp">Beli</span> secara massal',
      maximum_items_you_can_buy: 'Item maksimum yang dapat Anda beli dengan harga ini:',
      may_purchase_items_with_trade_hold: 'Fitur pembelian massal dapat membeli item dengan penahanan perdagangan.',
    },
  },
  affiliate: {
    ad_info: 'Jika Anda tidak melihat kotak tersebut, coba nonaktifkan adblock.',
    affiliate_code: 'Kode afiliasi',
    affiliate_link: 'Tautan afiliasi',
    level: 'Level',
    levels: 'Level </span>Afiliasi </span>',
    our_levels: 'Level kami',
    your_code: '<span class="text-cp">Kode afiliasi </span>Anda',
    your_affiliate_statistics: '<span class="text-cp">Statistik </span>afiliasi Anda',
    earn_money_by_simply_sharing: '<span class="text-cp">Hasilkan uang </span> hanya dengan membagikan kecintaan Anda pada BitSkins kepada audiens Anda!',
    percent_from_sale_fee: '{value}% dari biaya penjualan',
    join_the_bitskins_affiliate: 'Bergabunglah dengan program afiliasi BitSkins dan dapatkan komisi dari setiap penjualan yang dilakukan melalui tautan afiliasi unik Anda. Apakah Anda memiliki banyak pengikut atau hanya beberapa teman dekat, semakin banyak Anda berbagi, semakin banyak yang Anda hasilkan.',
    tile_1_title: 'Bagikan BitSkins dengan audiens Anda',
    tile_1_description: 'Buat tautan afiliasi Anda sendiri dalam hitungan detik dan mulailah membagikannya kepada teman atau audiens Anda.',
    tile_2_title: 'Saksikan keuntungan Anda bertambah',
    tile_3_title: 'Klaim penghasilan Anda',
    tile_3_description: 'Dana yang diperoleh dari program afiliasi dapat digunakan untuk membeli barang atau dapat ditarik dari BitSkins. Terserah Anda!',
    kyc_you_cannot_use: 'Anda tidak dapat menggunakan sistem afiliasi karena Anda belum melalui prosedur KYC. Anda dapat memulai proses verifikasi sekarang.',
    your_percentage: 'Persentase Anda',
    generated: 'Dihasilkan',
    individual_affiliate_program: 'Program afiliasi individu',
    if_you_or_your_business: 'Jika Anda atau bisnis Anda terlibat dalam industri esports atau memiliki jangkauan media sosial yang luas, silakan hubungi kami melalui <span>partnership{\'@\'}bitskins.com</span>. Kami dapat menawarkan ketentuan afiliasi individu.',
    invited_referrals: 'Referensi yang diundang',
    active_referrals: 'Referensi aktif',
    your_percentage_sales_fee: 'Persentase biaya penjualan Anda',
    your_total_earnings: 'Total penghasilan Anda',
    available_earnings: 'Penghasilan yang tersedia',
    you_can_claim_your_earnings_one_a_day: 'Anda dapat mengklaim penghasilan Anda sekali sehari. Setelah Anda mengklaimnya, penghasilan tersebut akan muncul di saldo Anda yang dapat ditarik dalam waktu 24 jam. Jumlah minimum untuk pembayaran adalah',
    to_reach_the_next_level: 'Untuk mencapai level berikutnya dan mendapatkan komisi yang lebih tinggi, Anda harus menghasilkan <span class="text-cp">{x}</span> dalam penjualan melalui referensi Anda.',
    any_user_that_registers_from_your_affiliate_link: 'Setiap pengguna yang mendaftar dari tautan afiliasi Anda akan secara otomatis ditetapkan sebagai wasit Anda',
    my_earnings: '<span class="text-cgs">Penghasilan saya</span>',
    referred_users: '<span class="text-purple" >Pengguna yang direferensikan</span>',
    code_updated: 'Kode afiliasi berhasil diperbarui',
    not_enough_money: 'Tidak cukup uang untuk ditransfer',
    account: 'Akun',
    referrals_sales: 'Riwayat penjualan rujukan',
  },
  profile: {
    hi: 'Hai',
    nav: {
      account: 'Akun',
      wallet: 'Dompet',
      transactions: 'Transaksi',
      statistics: 'Statistik',
      affiliate: 'Afiliasi',
      company: 'Perusahaan',
      trades: 'Perdagangan',
      items_history: 'Riwayat barang',
    },
    top_star: {
      you_are: 'Anda',
      top_star: 'BINTANG TERATAS',
      good_to_see_you: 'Hai "{username}", senang sekali bertemu dengan Anda di BitSkins!',
      appreciate_using: 'Kami menghargai bahwa Anda telah memutuskan untuk menggunakan platform kami,',
      extra_settings: 'oleh karena itu kami telah menyiapkan beberapa pengaturan tambahan untuk Anda.',
      show_nickname_selling: 'Tampilkan nama panggilan saya di halaman item saat menjual',
      show_nickname_store: 'Sorot nama panggilan saya di halaman toko',
    },
    basic: {
      basic_information: 'Informasi dasar',
      username: 'Nama pengguna',
      change_username: 'Ubah nama pengguna',
      registration_date: 'Tanggal pendaftaran',
      email: 'Email',
      change_email: 'Ubah email',
      password: 'Kata sandi',
      change_password: 'Ubah kata sandi',
      phone: 'Nomor telepon',
      change_phone: 'Ganti telepon',
      hide_balance: 'Sembunyikan saldo Anda',
      hide_balance_description: 'Jumlah dana akan disembunyikan dari header, namun akan tetap terlihat setelah menekan dompet.',
    },
    security: {
      you_can_access_your_account: 'Anda dapat mengakses akun Anda melalui API key. Dokumentasi API kami ada di',
      api_status: 'Status API',
      security: 'Keamanan',
      twofa: 'Otentikasi dua faktor',
      temporarily_block_my_account: 'Blokir sementara akun saya',
      temporarily_block_title: 'Blokir akun saya untuk sementara waktu <span class="text-cr">blokir akun saya</span>',
      temporarily_block_description: 'Jika Anda yakin bahwa akun Anda telah disusupi, Anda dapat memblokirnya untuk sementara.\nKami akan membuka blokir akun Anda setelah anda menghubungi tim dukungan kami.',
      temp_blocked: 'Akun Anda telah diblokir untuk sementara.\nSilakan hubungi tim bantuan kami untuk mengklarifikasi situasinya.',
      block_my_account: 'Blokir akun saya',
      delete_account: 'Menghapus akun',
      delete_my_account: 'Menghapus akun saya',
      sessions: 'Sesi',
      close_all_sessions: 'Tutup semua sesi',
      current_session: 'Sesi saat ini',
      active_sessions: 'Sesi aktif',
      no_other_sessions: 'Tidak ada sesi lain',
      removed: 'Dihapus',
      online: 'Online',
      api_key: 'API Key',
      api_key_not_available: 'API Key hanya dapat dilihat sekali selama pembuatannya',
      sensitive_hidden: 'Menyembunyikan informasi sensitif',
      ip_whitelist: 'Daftar IP yang diizinkan',
      add_ip_to_whitelist: 'Tambah pada daftar API yang diizinkan',
      disable_api_confirm: 'Mengonfirmasi penonaktifan akses API',
      disable_api_content: 'Apakah Anda yakin ingin menonaktifkan akses API untuk akun Anda?',
    },
    store: {
      my_store: 'Toko saya',
      store: 'toko',
      store_url: 'URL toko',
      store_alias: 'Nama alias toko',
      id_store: 'ID TOKO',
      hide_store: 'Sembunyikan halaman toko Anda',
      url_copied: 'URL toko disalin',
      total_items: 'Total item:',
      games: 'Permainan',
    },
    setting: {
      account_email: 'Email akun',
      update_email: 'Perbarui email',
      setup_email: 'Pengaturan email',
      update_password: '<span class="text-cp">Perbarui</span> kata sandi',
      set_password: '<span class="text-cp">Atur</span> kata sandi',
      enter_current_password: 'Masukkan kata sandi saat ini',
      password_changed: 'Kata sandi diubah',
      current_password: 'Kata sandi saat ini',
      enter_new_password: 'Masukkan kata sandi baru',
      repeat_new_password: 'Ulangi kata sandi baru',
      save_new_password: 'Simpan kata sandi baru',
      new_password: 'Kata sandi baru',
      repeat_password: 'Ulangi kata sandi',
      account_2fa: 'Akun 2FA',
      enable_2fa: 'Mengaktifkan 2FA',
      disable_2fa: 'Nonaktifkan 2FA',
    },
    transaction: {
      amount: 'Jumlah',
      type: 'Jenis',
      details: 'Detail',
      fee: 'Biaya',
      buyer_country: 'Negara pembeli',
      seller_country: 'Negara penjual',
      price: 'Harga',
      item_name: 'Nama barang',
      transaction_history: 'Riwayat transaksi',
      operation: 'Operasi',
      trade_id: 'ID Perdagangan',
      loading_trade_offers: 'Memuat penawaran pertukaran',
      no_trades_found: 'Tidak ada penawaran pertukaran yang ditemukan',
      id: 'ID',
      date: 'Tanggal',
      game: 'Permainan',
      items: 'Item',
      status: 'Status',
      time_left: 'Waktu tersisa',
      action: 'Aksi',
      trades_active: 'Pertukaran aktif',
      trades_history: 'Riwayat pertukaran',
      balance: 'Saldo',
      history: 'Riwayat Transaksi',
      pending: 'Transaksi tertunda',
      reports: 'Laporan yang diekspor',
      active_locks: 'Kunci aktif',
      export: 'Ekspor',
      export_to_csv: 'Ekspor ke .CSV',
      export_description: 'Pilih bulan dan tahun yang ingin Anda buat laporannya.',
      the_report_will_appear_in_the: 'Laporan akan muncul di ',
      tab_once_the_export_process_is_complete: 'tab setelah proses ekspor selesai.',
    },
  },
  fee: {
    individual: 'Individu',
    individual_fee: 'biaya perorangan',
    custom_sale_fee: 'Biaya penjualan khusus Anda',
    your_current_fees: 'Biaya Anda saat ini',
    high_tier: 'Tingkat tinggi',
    fee: 'Biaya',
    fee_up_to: 'biaya',
    sale_fee: 'Biaya penjualan',
    sales_fees: 'Biaya penjualan',
    see_all_levels: 'Lihat semua level',
    you_are_on_the: 'Anda berada di level',
    maximum_sales_fee: 'Biaya penjualan maksimum: {value}',
    your_total_sale_volume: 'Total volume penjualan Anda sejauh ini adalah',
    sales_fees_will_be_lowered: 'Biaya penjualan akan berkurang seiring dengan semakin banyaknya barang yang Anda jual.',
    level: 'level',
    your_level: 'Level anda:',
    progress: 'Kemajuan:',
    max_level: 'Level maksimum',
    next_level: 'Level selanjutnya:',
    total_income: 'Pendapatan total',
    total_revenue: 'Total pendapatan',
    sold_items: 'Barang yang terjual',
    page: {
      sales_fees_depends_on_two_factors: 'Di BitSkins, <span class="text-cp">BIAYA PENJUALAN</span> tergantung pada dua faktor:',
      the_price: '1. Harga yang Anda gunakan untuk menjual barang Anda',
      the_listing_type: '2. Jenis daftar:',
      listing_type_public: 'Publik - barang Anda dapat dilihat oleh semua pengguna di situs web',
      listing_type_private: 'Pribadi - barang Anda hanya dapat dilihat oleh orang yang Anda bagikan tautannya',
      fee_explanation: 'Semakin tinggi harga yang Anda jual, semakin rendah biaya penjualan yang akan Anda bayarkan. Biaya penjualan standar adalah mulai dari 2,5% (untuk daftar pribadi) hingga maksimum 10% (untuk daftar publik). Selain itu, kami memiliki 5 tingkat penjualan yang berbeda yang memungkinkan Anda untuk menurunkan biaya penjualan lebih rendah lagi. Aturannya sederhana - semakin banyak Anda menjual, semakin kecil biaya penjualan yang Anda bayarkan. Anda dapat mengurangi biaya penjualan hingga 2,4% (untuk daftar pribadi) atau hingga 9,8% (untuk daftar publik). Sistem biaya kami transparan dan tidak ada biaya tersembunyi.',
      default_sales_fees_title: '<span class="text-cp">Default</span> biaya penjualan',
      default_sale_fees_description: 'Jika Anda baru memulai dan belum menjual barang apa pun, maka biaya penjualan Anda adalah sebagai berikut:',
      how_to_reduce_my_sales_fees_title: '<span class="text-cp">Bagaimana cara mengurangi</span> biaya penjualan saya?',
      how_to_reduce_my_sales_fees_description: 'Di BitSkins kami memiliki 5 level penjualan. Masing-masing level (kecuali Level 1) mengurangi biaya penjualan Anda sebesar 0,05%. Untuk meningkatkan level Anda, Anda harus menjual item ke kisaran harga tertentu.',
      sales_fees_levels: 'Level <span class="text-cp">biaya penjualan</span>',
      price_range: 'Kisaran harga',
      total_sales: 'Total penjualan',
      fee_reduced_by: 'Biaya dikurangi dengan',
      individual_sales_fees_title: 'Biaya penjualan individu',
      individual_sales_fees_description: 'Jika Anda secara aktif menggunakan bitkoin dan omset bulanan Anda setidaknya<span class="span text-csfl6">{amount}</span>, jangan ragu untuk menghubungi kami. Kami dapat menawarkan <span class="text-csfl6">biaya penjualan yang lebih kecil </span> dan<strong>bantuan tambahan</strong>.',
    },
  },
  copy: {
    text_copied: 'Teks disalin',
    cannot_copy: 'Tidak dapat menyalin',
    name_copied: 'Nama disalin',
    cannot_copy_name: 'Tidak dapat menyalin nama',
    copy_link: 'Salin tautan',
  },
  share: {
    share_on_twitter: 'Bagikan di Twitter',
    share_on_facebook: 'Bagikan di Facebook',
    share_on_telegram: 'Bagikan di Telegram',
  },
  discord: {
    discord: 'Perselisihan',
    already_connected: 'Sudah terhubung',
    something_went_wrong: 'Ada yang tidak beres',
    success: 'Berhasil!',
    loading: 'Memuat...',
    connect_with_discord: 'Terhubung dengan Discord',
  },
  telegram: {
    already_connected: 'Sudah terhubung',
    something_went_wrong: 'Ada yang salah',
    success: 'Berhasil!',
    loading: 'Memuat...',
  },
  error: {
    error_404: 'Kesalahan 404',
    page_not_found: 'Halaman tidak ditemukan',
  },
  kyc: {
    description_1: 'Untuk memastikan keamanan transaksi yang dilakukan melalui situs web kami dan untuk mematuhi peraturan AML/KYC yang berlaku, kami mengharuskan Anda untuk menjalani proses verifikasi data (KYC). Terdapat tiga tingkat verifikasi. Setiap level meningkatkan atau sepenuhnya menghapus batasan dan memberi Anda akses ke metode pembayaran baru.',
    description_2_start: 'Syarat dan ketentuan terperinci mengenai proses verifikasi KYC dijelaskan dalam Ketentuan Layanan kami. Kami ingin meyakinkan Anda bahwa semua data yang Anda berikan akan digunakan sesuai dengan',
    description_2_end: 'Dengan memulai proses verifikasi KYC, Anda menyetujui pemrosesan data Anda oleh kami untuk tujuan yang dibenarkan secara hukum.',
    personal_data: 'Data pribadi',
    first_name: 'Nama depan',
    middle_name: 'Nama tengah',
    last_name: 'Nama belakang',
    street_name: 'Nama jalan',
    street_number: 'Nomor jalan',
    postal_code: 'Kode pos',
    city: 'Kota',
    province: 'Provinsi',
    country: 'Negara',
    start_kyc_verification: 'Mulai verifikasi KYC',
    upload: 'Unggah',
    uploaded: 'Diunggah',
    image_uploaded: 'Gambar diunggah',
    document_type: {
      id: 'ID',
      driving_license: 'Surat Izin Mengemudi',
      passport: 'Paspor',
      other: 'Lainnya',
    },
    limit: {
      crypto_withdraw: 'Batas penarikan kripto tahunan sebesar {amount}',
      crypto_withdraw_unlimited: 'Penarikan kripto tanpa batas',
      non_crypto_withdraw: 'Batas penarikan non-kripto tahunan sebesar {amount}',
      non_crypto_withdraw_unlimited: 'Penarikan non-kripto tanpa batas',
      crypto_deposit: 'Batas setoran kripto tahunan sebesar {amount}',
      crypto_deposit_unlimited: 'Setoran kripto tanpa batas',
      non_crypto_deposit: 'Batas setoran non-kripto tahunan sebesar {amount}',
      non_crypto_deposit_unlimited: 'Deposit non-kripto tanpa batas',
    },
    your_kyc_verification: 'Verifikasi KYC Anda',
    your_kyc_needs_an_update: 'KYC Anda memerlukan <span class="color-update">pembaruan</span>',
    need_update_reason: 'Sayangnya kami tidak dapat menyetujui akun Anda karena alasan berikut:',
    open_support: 'Dukungan terbuka',
    your_kyc_has_been_denied: 'KYC Anda telah <span class="color-denied">ditolak</span>',
    denied_description: 'KYC Anda telah ditolak, oleh karena itu Anda tidak dapat melakukan verifikasi KYC lagi.',
    deleted_description: 'KYC Anda telah ditolak. Anda dapat melakukan proses verifikasi lagi.',
    please_contact_our: 'Silakan hubungi tim',
    support: 'dukungan',
    clarify_the_situation: 'untuk mengklarifikasi situasinya.',
    your: 'Anda',
    kyc_title: 'Kenali Pelanggan Anda <span class="text-cp">verifikasi</span>',
    verification: 'verifikasi',
    pending: 'sedang menunggu',
    pending_description: 'Itu saja! Terima kasih telah melakukan proses verifikasi. Data Anda telah berhasil dikirimkan. Kami akan melakukan yang terbaik untuk memeriksa aplikasi Anda sesegera mungkin. Biasanya tidak lebih dari 12 jam. Kami akan mengirim email kepada Anda setelah akun Anda disetujui. Kesabaran Anda sangat kami hargai.',
    do_you_need_help: 'Apakah Anda memerlukan bantuan? Silakan hubungi',
    support_center: 'pusat dukungan kami',
    back_to_kyc: 'Kembali ke KYC',
    go_to_home: 'Kembali ke rumah',
    level_0: 'Level 0',
    level_1: 'Level 1',
    level_2: 'Level 2',
    limits: 'Batasan',
    benefits: 'Manfaat',
    requirements: 'Persyaratan',
    no_requirements: 'Tidak ada persyaratan',
    proof_of_address: 'Bukti alamat',
    all_benefits_from_the_basic_level: 'Semua manfaat dari tingkat dasar',
    personal_information: 'Informasi pribadi',
    identity_document: 'Dokumen identitas',
    selfie: 'Swafoto',
    all_benefits_from_level_1: 'Semua manfaat dari level 1',
    current: 'Saat ini',
    upending: 'Tertunda',
    update: 'Pembaruan',
    verification_blocked: 'Verifikasi diblokir',
    verify_now: 'Verifikasi sekarang',
    you_need_to_upgrade_to_level_1: 'Anda perlu meningkatkan ke level 1',
    upgrade_to_level_1: 'Tingkatkan ke level 1',
    upgrade_to_level_2: 'Tingkatkan ke level 2',
    kyc_verification: 'Verifikasi KYC',
    kyc_verification_span: '<span class="color-primary">Verifikasi KYC</span>.',
    kyc_verification_required: 'Verifikasi KYC diperlukan',
    everything_done: 'Semuanya selesai!',
    proof_of_residency: 'Bukti tempat tinggal',
    you_current_residential_address: 'Alamat tempat tinggal Anda saat ini',
    only_x_minutes: 'Hanya {minutes} menit!',
    identity_verification: 'Verifikasi identitas',
    take_a_selfie: 'Mengambil foto selfie',
    step: 'Langkah {step}',
    country_of_residence: 'Negara tempat tinggal',
    full_name: 'Nama lengkap',
    date_of_birth: 'Tanggal lahir',
    nationality: 'Kebangsaan',
    choose_your_document: 'Pilih dokumen Anda',
    choose_document_description_1: 'Pilih dokumen yang ingin Anda gunakan selama verifikasi.',
    choose_document_description_2: 'Kami hanya menerima dokumen yang sah yang dikeluarkan oleh pemerintah.',
    choose_document_description_3: 'Dokumen lain yang tidak ada dalam daftar akan ditolak.',
    document_number: 'Nomor dokumen',
    country_of_issue: 'Negara penerbit',
    document_issue_date: 'Tanggal penerbitan dokumen',
    document_expiry_date: 'Tanggal kedaluwarsa dokumen',
    files_requirements: 'Persyaratan file',
    format: 'Format {format} atau format {or}',
    maximum_file_size: 'Ukuran file maksimum {size}',
    minimum_picture_size: 'Ukuran gambar minimum {size} piksel',
    not_accepted_documents: 'Dokumen yang tidak diterima',
    expired: 'Kadaluarsa',
    edited: 'Diedit',
    black_and_white: 'Hitam dan putih',
    broken_or_damaged: 'Rusak atau rusak',
    illegible_blurred_or_reflective: 'Tidak terbaca, kabur, atau memantul',
    cut_off_or_overcropped: 'Terpotong atau dipotong berlebihan',
    upload_front_page: 'Unggah halaman depan',
    upload_back_page: 'Unggah halaman belakang',
    selfie_description: 'Silakan unggah foto diri Anda yang sedang memegang kartu identitas dan kertas bertuliskan nama Anda, "BitSkins.com", dan tanggal hari ini.',
    example_of_correctly_taken_photo: 'Contoh foto yang diambil dengan benar',
    with_sunglasses_cap_or_mask: 'Dengan kacamata hitam, topi atau masker',
    information_covered_by_finger: 'Informasi pada dokumen Anda ditutupi oleh jari-jari Anda',
    face_covered_by_document: 'Wajah Anda tertutup oleh dokumen Anda',
    out_of_focus: 'Wajah Anda atau dokumen Anda berada di luar fokus',
    upload_selfie: 'Unggah foto selfie',
    send_level_1_kyc_request: 'Kirim permintaan KYC Level 1',
    address_line_1: 'Baris alamat 1',
    address_line_2_optional: 'Baris alamat 2 (opsional)',
    state_or_province: 'Negara Bagian atau Provinsi',
    proof_of_residency_description: 'Unggah dokumen yang membuktikan alamat tempat tinggal Anda saat ini yang telah Anda berikan pada langkah sebelumnya. Pastikan nama lengkap Anda terlihat pada dokumen tersebut.',
    upload_document: 'Unggah dokumen',
    accepted_documents: 'Dokumen yang diterima',
    utility_bills: 'Tagihan utilitas',
    bank_statements: 'Laporan bank',
    tax_returns: 'Surat pemberitahuan pajak',
    government_letters: 'Surat-surat pemerintah',
    other_document_residential: 'Dokumen lain yang mengonfirmasi alamat tempat tinggal Anda saat ini',
    send_level_2_kyc_request: 'Kirim permintaan KYC Level 2',
    submit: 'Kirim',
    submit_correct: 'Kirimkan informasi yang benar',
    next: 'Berikutnya',
    send_to_verify: 'Kirim untuk verifikasi',
    document_verification: 'Verifikasi dokumen',
    level: 'Tingkat KYC',
    please_reupload_following_photos: 'Silakan unggah ulang foto-foto berikut ini',
    please_reupload: 'Silakan unggah ulang',
    we_need_additional_information: 'Kami membutuhkan informasi tambahan',
    file_format_not_supported: 'Format file ini tidak didukung.',
    the_file_is_too_big: 'File {file_name} terlalu besar ({file_size}), <br> maksimum {size_limit}.',
    field: {
      document_image_a: 'Halaman depan dokumen Anda',
      document_image_b: 'Halaman belakang dokumen Anda',
      user_image: 'Swafoto Anda',
      address_image: 'Bukti tempat tinggal',
      additional_selfie: 'Swafoto tambahan',
    },
    back_to_bitskins: 'Kembali ke BitSkins',
    withdrawals: 'Penarikan',
    get_to_the_next_level: 'Naik ke level berikutnya untuk menyingkirkan<br> batasan dan mendapatkan akses<br> ke metode pembayaran baru.',
    after_the_first_page_is_validated: 'Setelah foto pertama divalidasi, Anda akan dapat mengunggah halaman kedua.',
    accepted: 'Diterima',
  },
  camera: {
    cancel: 'Batal',
    check_permissions: 'Periksa izin',
    take_a_new_photo: 'Ambil foto baru',
    take_a_photo: 'Ambil foto',
    use_camera: 'Gunakan kamera',
    use_photo: 'Gunakan foto',
    we_will_need_access_to_your_camera: 'Kami memerlukan akses ke kamera Anda untuk melanjutkan.',
    please_follow_these_steps: 'Ikuti langkah-langkah berikut ini',
    select_the_camera_icon: 'Pilih ikon <strong>kamera</strong> di bilah alamat Anda',
    select_always_allow_access: 'Pilih <strong>Selalu izinkan untuk mengakses kamera Anda</strong>',
    select_done: 'Pilih <strong>Selesai</strong>;',
  },
  review: {
    leave_a_review: 'Tinggalkan ulasan',
    our_reviews: 'Ulasan kami',
    if_youre_happy: 'Jika <span class="color-primary">Anda senang</span> dengan layanan ini, ',
    we_would_appreciate: 'kami akan sangat menghargai jika Anda memberikan <span class="color-primary">ulasan pada Trustpilot</span> dengan membagikan pengalaman Anda untuk membantu kami. Terima kasih!',
    if_youre_happy_we_would_appreciate: 'Jika <span class="color-primary">Anda senang </span>dengan layanan ini, kami akan sangat menghargai jika Anda memberikan <span class="color-primary">ulasan tentang Trustpilot </span>berbagi pengalaman Anda untuk membantu kami. Terima kasih!',
  },
  support: {
    center: 'Pusat dukungan',
    tickets_list: 'Daftar tiket',
    create_ticket: 'Buat tiket',
    submit_ticket: 'Kirim tiket',
    close_ticket: 'Tutup tiket',
    submit_disclaimer: 'Untuk mempercepat pekerjaan kami dan menerima balasan secepatnya, pastikan Anda tidak membuka banyak tiket terkait masalah yang sama. Waktu respons rata-rata adalah <strong>beberapa jam</strong>. Anda dapat menghubungi kami dalam bahasa <strong>Inggris, Polandia, dan Swedia</strong>. Terima kasih atas kerja sama Anda.',
    enter_your_message: 'Masukkan pesan Anda',
    new_ticket: 'Tiket baru',
    your_ticket: 'Tiket Anda',
    bitskins_team: 'Tim BitSkins',
    ticket_has_been_closed_by: 'Tiket telah <span>ditutup</span> oleh <span>{by}</span>',
    ticket_has_been_closed: 'Tiket telah <span>ditutup</span>;',
    conversation_history: 'Riwayat percakapan:',
    your_reply: 'Balasan Anda...',
    last_reply_by: 'Balasan terakhir oleh',
    send: 'Kirim',
    ticket: 'Tiket',
    title: 'Judul',
    category: {
      payments: 'Pembayaran',
      payment_crypto_deposit: 'Setoran kripto',
      payment_crypto_withdraw: 'Penarikan kripto',
      payment_standard_deposit: 'Metode setoran standar',
      payment_standard_withdraw: 'Metode penarikan standar',
      market: 'Pasar',
      market_item_issue: 'Masalah barang',
      market_buy_orders: 'Beli pesanan',
      market_bulk_buy: 'Pembelian massal',
      market_missing_screenshot: 'Tangkapan layar hilang',
      market_missing_float: 'Pelampung yang hilang',
      market_wrong_price: 'Harga Steam salah',
      market_other: 'Lainnya',
      trading: 'Perdagangan',
      trading_deposit: 'Setoran barang',
      trading_withdraw: 'Penarikan barang',
      account: 'Akun',
      account_2fa: 'Masalah 2FA',
      account_email: 'Masalah email',
      account_kyc: 'KYC',
      account_affiliate: 'Sistem afiliasi',
      account_restrictions: 'Pembatasan',
      account_other: 'Lainnya',
      other: 'Lainnya',
      bug_report: 'Laporan bug',
      api: 'API',
      suggestions: 'Saran',
      business_inquiry: 'Pertanyaan bisnis',
      general_inquiry: 'Pertanyaan umum',
    },
    extra: {
      txid_url: 'TXID/url',
      amount: 'Jumlah',
      crypto: 'Mata uang kripto',
      disclaimer_visa_1: 'Harap diingat, biasanya diperlukan waktu hingga 5 hari kerja sebelum uang tersedia di rekening bank Anda.',
      disclaimer_visa_2: 'Harap pastikan jenis kartu yang Anda gunakan adalah Visa dan bukan Mastercard. Saat ini kami tidak mendukung penarikan dengan Mastercard.',
      card_digits: '4 digit terakhir kartu Anda',
      binance_id: 'ID Binance Anda',
      wallet_address: 'Alamat dompet',
      provider: 'Penyedia',
      transaction_id: 'ID Transaksi',
      type: 'Jenis',
      method: 'Metode',
      item_link: 'Tautan ke item',
      bot_received_item: 'Tautan profil Steam bot yang menerima item Anda',
      trade_offer_id: 'ID penawaran pertukaran',
      can_be_found_here: 'dapat ditemukan di sini',
      email: 'Masukkan email',
    },
  },
  service: {
    market: {
      buy: 'Beli',
      sell: 'Jual',
      fee: 'Biaya penjualan',
      buy_order: 'Beli pesanan',
      bargain: 'Tawar-menawar',
      instant_sell: 'Jual instan',
      bump: 'Bump',
      bump_package: 'Paket Bump',
    },
    deposit: {
      gift_code: 'Kode hadiah',
      bitcoin: 'Setor BTC',
      litecoin: 'Setor LTC',
      ethereum: 'Setor ETH',
      unlimint: 'Setoran dengan kartu bank',
      binance_pay: 'Setor dengan Binance Pay',
      binancepay: 'Setor dengan Binance Pay',
      available_coupons: 'Kupon yang tersedia:',
      redeem_coupon: 'Tukarkan kupon',
      enter_coupon_code: 'Masukkan kode kupon',
      open_binance_website: 'Buka situs web Binance',
      list_of_active_transactions: 'Daftar transaksi aktif:',
      transaction_needs_at_least_x_confirmations: 'Transaksi membutuhkan setidaknya {x} konfirmasi sebelum dana muncul di akun Anda.',
      billing_information: '<span class="text-cp">Penagihan</span> informasi',
      coupon: {
        coupon: 'Kupon',
        make_a_gift: 'Jadikan diri Anda atau orang lain <span class="text-cp">hadiah</span>',
        bitskins_coupons_are_a_good_alternative: 'Kupon BitSkins adalah alternatif yang baik untuk metode pembayaran standar dan ide hadiah yang bagus. Anda bisa membelinya dari mitra kami yang menawarkan banyak metode pembayaran.',
        dont_wait: '<span class="text-cp">Jangan menunggu dan mengisi saldo Anda </span> dengan kupon BitSkins atau berikan seseorang <br> <span class="text-cp">hadiah orisinil </span> (kita semua tahu ada yang punya inventaris kosong).',
        kinguin: 'Kinguin (biaya baru yang diturunkan)',
      },
      crypto: {
        get_wallet_address: 'Dapatkan alamat dompet',
        your_wallet_address: 'Alamat dompet Anda',
        this_address_is_only_for_x: 'Alamat ini hanya untuk setoran {x}. Jangan mengirim kripto lain ke alamat ini.',
        this_address_will_not_expire: 'Alamat ini tidak akan kedaluwarsa. Anda dapat menggunakannya kapan saja.',
        choose_alternative_address: 'Pilih alamat alternatif',
        the_acutal_amount_you_will_be_credited: 'Jumlah aktual yang akan dikreditkan ke akun Anda tergantung pada harga {x} pada saat kami menerima pembayaran Anda.',
        only_l1_transactions: '<span class="text-cy">Hanya transaksi L1 yang didukung. Jangan gunakan transaksi internal dan kontrak pintar!</span>',
      },
      zen: {
        zen: 'Deposit dengan ZEN',
        deposit_started: 'Setoran ZEN dimulai, ',
        open_the_zen_deposit_page: 'buka halaman deposit ZEN',
        processing_fee: 'ZEN akan menambahkan biaya pemrosesan ke transaksi yang tergantung pada metode pembayaran yang dipilih.<br> Jumlah transaksi akhir akan terlihat di situs web mereka.',
        each_transaction_is_reviewed: 'Setiap transaksi ditinjau oleh ZEN Pay dan dapat memakan waktu antara satu menit hingga beberapa jam untuk menyelesaikannya.',
      },
      the_minimum_deposit_amount_is: 'Jumlah setoran minimum adalah {amount}.',
      the_maximum_deposit_amount_is: 'Jumlah setoran maksimum adalah {amount}.',
    },
    withdraw: {
      only_binance_com_is_supported: '<span class="text-cy">Kami menawarkan pembayaran hanya ke binance.com (binance.us tidak didukung).</span>',
      bitcoin: 'Menarik BTC',
      litecoin: 'Tarik LTC',
      ethereum: 'Tarik ETH',
      unlimint: 'Menarik ke kartu VISA',
      tipalti: {
        tipalti: 'Penarikan dengan Tipalti',
        tipalti_allows_you_to_withdraw: 'Tipalti memungkinkan Anda untuk menarik dana Anda ke rekening bank dan PayPal Anda.',
        you_dont_have_a_tipalti_acount: 'Anda tidak memiliki akun Tipalti?',
        you_have_to_create_an_account: 'Untuk menarik dana Anda melalui Tipalti, pertama-tama Anda harus membuat akun di situs web mereka.<br> Anda dapat melakukannya dengan mengklik tombol di bawah ini.',
        create_tipalti_account: 'Buat akun Tipalti',
        check_your_email: 'Silakan periksa <span class="text-cp">kotak masuk email Anda </span> dan klik tautan konfirmasi untuk menyelesaikan proses pembuatan akun. Jika Anda tidak dapat menemukan pesan email di kotak masuk Anda, silakan periksa folder spam Anda',
        payment_method: 'Metode pembayaran',
        tipalti_panel: 'Panel Tipalti',
        tipalti_payouts_incur_a_fee: 'Pembayaran Tipalti dikenakan biaya yang bisa mencapai $26. Biaya ini tergantung pada metode pembayaran yang dipilih. Di bawah ini Anda dapat menemukan tabel dengan biaya untuk setiap metode pembayaran.',
        fee_per_payment: 'Biaya per pembayaran',
        rejection_fee: 'Biaya penolakan',
        echeck_local: 'eCheck (Lokal)',
        paypal_non_us: 'PayPal (Penduduk non-AS)',
        paypal_us: 'PayPal (Penduduk AS)',
        wire_transfer_non_us_non_usd: 'Transfer Bank (Penduduk non-AS yang dibayar dalam mata uang non-AS)',
        wire_transfer_non_us_usd: 'Transfer Kawat (Penduduk non-AS dibayar dalam USD)',
        wire_transfer_us: 'Transfer Kawat (Penduduk AS)',
        up_to_21_usd: 'hingga $21,00',
        up_to_2_usd: 'hingga $2.00',
      },
      payoneer: 'Penarikan dengan Payoneer',
      binance_pay: 'Penarikan dengan Binance Pay',
      binancepay: 'Tarik dengan Binance Pay',
      p2p: 'Transfer P2P',
      payouts_are_performed_on_a_rolling_basis: 'Pembayaran dilakukan secara bergilir hingga 5 menit setelah diminta.',
      your_payout_will_be_processed_at_the_current_rate: 'Pembayaran Anda akan diproses dengan kurs saat ini.',
      please_verify_the_wallet_address: 'Harap verifikasi alamat dompet. Kami tidak dapat mengembalikan dana penarikan yang salah.',
      the_data_controller: 'Pengontrol data dan pihak yang membuat kontrak dengan Unlimint sehubungan dengan pembayaran yang diproses oleh mereka adalah Bitskins Sp. z o.o. dengan kantor terdaftar di 40-246 Katowice, Porcelanowa str. 23, Polandia, terdaftar di bawah nomor: 0000810143 - rincian lebih lanjut dapat ditemukan di Kebijakan Privasi dan ToS.',
      visa_withdrawals_are_processed_instantly: 'Penarikan VISA diproses secara instan. Namun, dalam beberapa kasus, mungkin diperlukan waktu hingga beberapa hari sebelum uang masuk ke rekening bank Anda.',
      card_info: 'Info kartu',
      ccv: 'CCV',
      add_new_deposit_needed: 'Tambah baru (perlu deposit)',
      you_can_have_max_3_bank_cards: 'Anda dapat memiliki maksimal tiga kartu bank yang ditetapkan ke akun Anda.',
      your_cards_amount: '<span class="text-cp">Kartu </span> Anda ({x}/3)',
      the_minimum_withdraw_amount_is_x: 'Jumlah penarikan minimum adalah {x}.',
      the_maximum_withdraw_amount_is_x: 'Jumlah penarikan maksimum adalah {x}.',
      enter_amount: 'Masukkan jumlah',
      go_to_card_deposit: 'Pergi ke deposit kartu',
      to_be_able_to_withdraw_your_funds_you_need_to_verify_your_card: 'Untuk dapat menarik dana, Anda perlu memverifikasi kartu Anda terlebih dahulu. Anda dapat melakukannya dengan menyetor $1.',
      deposited_funds_are_non_withdrawable: 'Harap diingat bahwa dana yang telah disetorkan tidak dapat ditarik dan hanya dapat digunakan untuk pembelian.',
      we_do_not_support_mastercard_withdrawals: 'Kami tidak mendukung penarikan ke kartu MasterCard dan kartu yang diterbitkan di negara-negara berikut: Bosnia dan Herzegovina, Kanada, Mesir, Jepang, Kamboja, Korea (Republik), KOSOVO, Makedonia Utara, Amerika Serikat, Argentina.',
      your_card_is_valid_until: 'Kartu Anda berlaku hingga 16.02.2023, pukul 15:35 (UTC). Setelah itu, Anda harus memverifikasi ulang kartu Anda dengan menyetor $5.',
      card_verification_required: '<span class="text-cp">Verifikasi kartu</span> diperlukan',
      card: 'Kartu',
      add_new_card: '<span class="text-cp">Tambah kartu baru</span>',
      how_to_find_my_binance_id: 'Bagaimana cara menemukan ID pengguna (BUID) saya di Binance?',
      how_to_find_my_pay_id: 'Bagaimana cara menemukan ID Pembayaran saya di Binance?',
      how_to_find_my_email: 'Bagaimana cara menemukan email saya di Binance?',
      binance_id: 'ID Binance',
      receiver_type: 'Jenis penerima',
      i_do_not_have_a_binance_account: 'Saya tidak memiliki akun Binance',
      i_have_a_binance_account: 'Saya memiliki akun Binance',
      binance_account: '<span class="text-cp">Akun Binance</span> Akun',
      the_fee_is_already_included_in_the_current_x_rate: 'Biaya {fee}% sudah termasuk dalam kurs {x} saat ini.',
    },
    wallet: {
      transfer: 'Transfer dana',
      refund: 'Pengembalian dana',
      available_payment_methods: 'Metode pembayaran yang tersedia',
      bank_cards: 'Kartu bank',
      kyc_required_for_this_payment_method: 'Anda tidak dapat menggunakan metode pembayaran ini karena Anda belum melalui prosedur KYC. Anda dapat memulai proses verifikasi sekarang.',
      kyc_limit_exceeded: 'Anda tidak dapat menggunakan metode pembayaran ini karena Anda telah melampaui batas transaksi untuk level KYC Anda. Anda sekarang dapat memulai proses verifikasi untuk menghapus batasan tersebut.',
      no_limit: 'Tidak ada batasan',
      limits_info: 'Di Bitskins <strong>setiap transaksi memiliki pengatur waktu dan batasnya sendiri yang diatur ulang satu tahun setelah transaksi dilakukan </strong>. Jumlah maksimum yang dapat Anda setor atau tarik ditampilkan dalam grafik. Anda dapat meningkatkan limit atau menghilangkannya sama sekali dengan melalui prosedur KYC.',
      crypto_deposits: 'Setoran kripto',
      crypto_withdrawals: 'Penarikan kripto',
      standard_deposits: 'Setoran standar',
      standard_withdrawals: 'Penarikan standar',
      coupons_are_excluded_from_the_limit: '* kupon tidak termasuk dalam limit',
      x_type_does_not_incur_any_fees: '{x} {type} tidak dikenakan biaya apa pun.',
      incur_fees_of: 'dikenakan biaya sebesar',
      plus: ' plus ',
      the_minimum_type_amount_is: 'Jumlah <span class="color-primary">minimum {type}</span> adalah',
      the_maximum_type_amount_is: 'Jumlah <span class="color-primary">maksimum {type}</span> adalah',
      due_to_unstable_crypto_network: 'Karena jaringan kripto yang tidak stabil, Anda mungkin mengalami beberapa penundaan.',
      binance_temporarily_disabled: 'Penarikan Binance dinonaktifkan hingga hari Senin (28.08.2023)',
    },
  },
  enum: {
    report_type: {
      balance: 'Saldo',
      sell: 'Dijual',
      buy: 'Dibeli',
    },
    report_status: {
      empty: 'Kosong',
      pending: 'Tertunda',
      done: 'Selesai',
    },
    autobump_period: {
      hour_1: '1h',
      hour_3: '3h',
      hour_6: '6h',
      hour_12: '12h',
      hour_24: '24h',
      hour_48: '48h',
    },
    autobump_status: {
      not_enough_bumps: 'Tidak cukup banyak bump',
      finished: 'Selesai',
      cancelled: 'Dibatalkan',
      pending: 'Tertunda',
      active: 'Aktif',
    },
    inventory_status: {
      issue: 'Masalah',
      not_available: 'Tidak tersedia',
      deleted: 'Dihapus',
      withdrawn: 'Ditarik kembali',
      delisted: 'Dihapus',
      ready: 'Siap',
      listed: 'Terdaftar',
      listed_private: 'Tercatat swasta',
      sold: 'Dijual',
      withdraw_queue: 'Tarik antrian',
      withdraw_pending: 'Penarikan tertunda',
      instant_sell: 'Jual instan',
    },
    service: {
      market: {
        buy: 'Beli',
        sell: 'Jual',
        fee: 'Biaya penjualan',
        buy_order: 'Pesanan beli',
        bargain: 'Tawar-menawar',
        instant_sell: 'Jual instan',
        bump: 'Bump',
        bump_package: 'Paket Bump',
      },
      deposit: {
        bitcoin: 'Setor BTC',
        litecoin: 'Setor LTC',
        ethereum: 'Setor ETH',
        unlimint: 'Deposit dengan kartu bank',
        zen: 'Setor dengan ZEN',
        gift_code: 'Kode hadiah',
        binancepay: 'Setor dengan Binance Pay',
      },
      withdraw: {
        bitcoin: 'Tarik BTC',
        litecoin: 'Tarik LTC',
        ethereum: 'Tarik ETH',
        unlimint: 'Menarik ke kartu VISA',
        tipalti: 'Menarik dengan Tipalti',
        payoneer: 'Menarik dengan Payoneer',
        binancepay: 'Menarik dengan Binance Pay',
        p2p: 'Transfer P2P',
      },
      wallet: {
        transfer: 'Transfer dana',
        refund: 'Pengembalian dana',
      },
      marketing: {
        coupon: 'Kupon',
        referral: 'Referensi',
        affiliate: 'Afiliasi',
      },
    },
  },
  meta: {
    default_title: 'BitSkins 2024',
    default_description: 'BitSkins menawarkan platform yang mulus untuk membeli dan menjual item CS2, DOTA2, TF2, RUST Anda. Jelajahi berbagai pilihan senapan, pisau, sarung tangan, dan banyak lagi. Bergabunglah sekarang untuk berdagang dengan mudah!',
    home_title: 'BitSkins.com - Beli & Jual Skin CS2. Perdagangan Cepat, Mudah & Aman',
    home_description: 'BitSkins menawarkan platform yang mulus untuk membeli dan menjual item CS2, DOTA2, TF2, RUST Anda. Jelajahi berbagai pilihan senapan, pisau, sarung tangan, dan banyak lagi. Bergabunglah sekarang untuk berdagang dengan mudah!',
    support_title: 'Dukungan BitSkins: Dapatkan Bantuan untuk Kebutuhan Perdagangan CS2 Anda',
    support_description: 'Butuh bantuan untuk trading CS2 Anda? Kunjungi halaman dukungan BitSkins untuk mendapatkan bantuan secepatnya. Tim kami siap menjawab pertanyaan Anda, menyelesaikan masalah, dan memberikan panduan.',
    item_title: '{item} - Skin {game} | Temukan dan Perdagangkan Item {game} yang Anda Inginkan',
    item_description_csgo: 'Temukan dan tukarkan skin CS2 yang Anda inginkan di BitSkins. Jelajahi koleksi senapan, pisau, sarung tangan, dan banyak lagi. Beli, jual, atau tarik secara instan. Mulai menjelajah sekarang!',
    item_description_cs2: 'Temukan dan tukarkan skin CS2 yang Anda inginkan di BitSkins. Jelajahi koleksi senapan, pisau, sarung tangan, dan banyak lagi. Beli, jual, atau tarik secara instan. Mulai menjelajah sekarang!',
    item_description_dota2: 'Temukan dan tukarkan skin DOTA2 yang Anda inginkan di BitSkins. Jelajahi koleksi bangsal, musik, bundel, dan banyak lagi. Beli, jual, atau tarik secara instan. Mulai menjelajah sekarang!',
    item_description_tf2: 'Temukan dan tukarkan item TF2 yang Anda inginkan di BitSkins. Jelajahi koleksi kosmetik, ejekan, peti, dan banyak lagi. Beli, jual, atau tarik secara instan. Mulai menjelajah sekarang!',
    item_description_rust: 'Temukan dan tukarkan item RUST yang Anda inginkan di BitSkins. Jelajahi koleksi pakaian, senjata, sumber daya, dan banyak lagi. Beli, jual, atau tarik secara instan. Mulai menjelajah sekarang!',
    market_title: 'Pasar BitSkins: Jelajahi dan Perdagangkan Item {game} dengan Mudah',
    market_description_csgo: 'Masuki BitSkins Market untuk menjelajahi dan memperdagangkan berbagai macam item CS2 dengan mudah. Temukan penawaran terbaik untuk skin, kunci, kapsul, dan banyak lagi. Beli, jual, atau tarik secara instan.',
    market_description_cs2: 'Masuki BitSkins Market untuk menjelajahi dan memperdagangkan berbagai macam item CS2 dengan mudah. Temukan penawaran terbaik untuk skin, kunci, kapsul, dan banyak lagi. Beli, jual, atau tarik secara instan.',
    market_description_dota2: 'Masuk ke Pasar BitSkins untuk menjelajahi dan memperdagangkan berbagai macam item DOTA2 dengan mudah. Temukan penawaran terbaik untuk bangsal, musik, bundel, dan banyak lagi. Beli, jual, atau tarik secara instan.',
    market_description_tf2: 'Masuk ke Pasar BitSkins untuk menjelajahi dan memperdagangkan berbagai macam item TF2 dengan mudah. Temukan penawaran terbaik untuk kosmetik, ejekan, peti, dan banyak lagi. Beli, jual, atau tarik secara instan.',
    market_description_rust: 'Masuki Pasar BitSkins untuk menjelajahi dan memperdagangkan berbagai macam item RUST dengan mudah. Temukan penawaran terbaik untuk pakaian, senjata, sumber daya, dan banyak lagi. Beli, jual, atau tarik secara instan.',
    market_item_title: 'Pasar BitSkins: {skin}: {game} Pasar',
    store_title: 'Toko Pengguna BitSkins: {alias} - {game} Etalase Barang',
    store_description: 'Toko Pengguna BitSkins untuk memamerkan dan menjual barang-barang Anda. Tetapkan harga Anda, berinteraksi dengan pembeli, dan bangun kehadiran Anda di komunitas perdagangan.',
    login_title: 'Login BitSkins: Akses Aman ke Akun Perdagangan CS2 Anda',
    login_description: 'Masuk ke akun BitSkins Anda dengan aman. Akses inventaris CS2 Anda, kelola item, lakukan transaksi, dan nikmati pengalaman pertukaran yang lancar.',
    steam_login_title: 'Masuk dengan Steam',
    profile_title: 'Pengaturan akun Anda',
    wallet_title: 'Dana BitSkins Anda',
    affiliate_title: 'Panel Afiliasi BitSkins: Dapatkan Hadiah untuk referensi',
    affiliate_description: 'Bergabunglah dengan program Afiliasi BitSkins dan dapatkan hadiah dengan mereferensikan penggemar skin. Dapatkan keuntungan dari program afiliasi yang menguntungkan, lacak referensi Anda dan maksimalkan penghasilan Anda.',
    statistics_title: 'Statistik Penjualan BitSkins: Mengungkap Tren & Wawasan Pasar',
    statistics_description: 'Jelajahi statistik komprehensif tentang BitSkins untuk mendapatkan wawasan berharga tentang tren perdagangan CS2. Analisis data pasar, popularitas item, dan banyak lagi untuk mengoptimalkan strategi perdagangan Anda.',
    sales_fees_title: 'Biaya Penjualan BitSkins: Harga Transparan untuk Penjualan CS2 Anda',
    sales_fees_description: 'Dapatkan pemahaman yang jelas tentang struktur biaya penjualan BitSkins. Biaya transparan kami memastikan keadilan dan kesederhanaan untuk penjualan CS2 Anda. Pelajari lebih lanjut.',
    checkout_title: 'Keranjang BitSkins: Pembayaran yang Nyaman untuk item CS2',
    checkout_description: 'Sederhanakan pengalaman pertukaran CS2 Anda dengan BitSkins Cart. Kelola item Anda dengan mudah, tinjau pesanan Anda, dan lanjutkan ke pembayaran yang aman. Nikmati proses pertukaran yang mulus hari ini!',
    steam_inventory_title: 'Inventaris Steam {game} saya',
    bs_inventory_title: 'Inventaris {game} BitSkins saya',
    selling_inventory_title: 'Item {game} Saya yang Terdaftar',
    buy_order_create_title: 'Membuat pesanan beli untuk {game}',
    buy_order_active_title: 'Pesanan beli aktif untuk {game}',
    buy_order_title: 'Membeli pesanan untuk {game}',
    trades_active_title: 'Jual beli aktif',
    trades_history_title: 'Riwayat perdagangan',
    transactions_title: 'Transaksi',
    favorites_title: 'Item Favorit',
    kyc_title: 'Formulir aplikasi Kenali Pelanggan Anda (KYC)',
    tos_title: 'Ketentuan Penggunaan BitSkins: Pedoman untuk Perdagangan yang Aman dan Terpercaya',
    tos_description: 'Tinjau Ketentuan Penggunaan kami untuk perdagangan yang aman dan tepercaya. Biasakan diri Anda dengan kebijakan dan kewajiban kami. Berdagang dengan aman di BitSkins.',
    privacy_policy_title: 'Kebijakan Privasi BitSkins: Melindungi Informasi Pribadi Anda',
    privacy_policy_description: 'Baca Kebijakan Privasi BitSkins untuk mempelajari bagaimana kami melindungi dan menangani informasi pribadi Anda. Kepercayaan dan transparansi adalah inti dari komitmen kami.',
    cookie_policy_title: 'Kebijakan Cookie BitSkins: Privasi Anda Penting Bagi Kami',
    cookie_policy_description: 'Di BitSkins, kami menghargai privasi Anda. Baca Kebijakan Cookie kami untuk memahami bagaimana kami menggunakan cookie dan teknologi serupa. Kepercayaan dan keamanan data Anda adalah prioritas utama kami.',
    docs_v1_title: 'BitSkins API V1: Versi API Lama',
    docs_v1_description: 'Integrasikan BitSkins API V1 untuk perdagangan yang lancar. Akses dokumentasi untuk mengoptimalkan kemampuan trading Anda. Tingkatkan ke versi terbaru untuk mendapatkan fitur-fitur baru.',
    docs_v2_title: 'BitSkins API V2: Versi API Terbaru',
    docs_v2_description: 'Buka fitur-fitur baru dengan BitSkins API V2. Tingkatkan strategi dan efisiensi perdagangan Anda. Jelajahi dokumentasi komprehensif kami sekarang!',
    docs_migration_title: 'Migrasi API BitSkins: Transisi dengan mulus ke API Baru',
    docs_migration_description: 'Migrasi ke API BitSkins baru dengan lancar dengan panduan komprehensif kami. Jelajahi fitur-fitur yang diperbarui dan proses integrasi untuk pengalaman trading yang lebih baik.',
  },
  alt: {
    envelope: 'Amplop',
    app_store: 'App Store',
    google_store: 'Google Store',
  },
  time: {
    seconds: 'detik',
  },
  calendar: {
    week: 'Minggu',
    month: 'Bulan',
    lifetime: 'Seumur hidup',
  },
  docs: {
    docs: 'Dokumen',
    api: 'API',
    api_v1: 'API V1 (Gateway)',
    api_v2: 'API V2',
    api_migration_guide: 'Panduan Migrasi API',
    request_parameters: 'Parameter permintaan',
    sample_request: 'Permintaan sampel',
    sample_response: 'Contoh tanggapan',
    request_schema: 'Skema permintaan',
    enums: 'ENUM',
  },
  wallet: {
    coupon_redeemed: 'Anda telah menukarkan kupon {amount}',
    balance_changed: 'Saldo telah diperbarui',
    transfer_p2p_confirm: 'Konfirmasikan transfer dana ke p2p.bitskins.com',
    transfer_p2p_confirm_needed: 'Anda perlu mengkonfirmasi transfer',
    transfer_p2p_success: 'Dana Anda telah ditransfer ke p2p.bitskins.com',
    transfer_funds: 'Transfer dana',
    deposit_started: 'Deposit dimulai',
    card_removed: 'Kartu dihapus',
    confirm_card_remove: 'Apakah Anda yakin ingin menghapus kartu ini?',
    delete_card: 'Hapus kartu',
    deposit: 'deposit',
    withdraw: 'menarik',
    security_code: 'Kode keamanan',
    security_code_ccv: 'Kode keamanan',
    card_number: 'Nomor kartu',
    full_name: 'Nama lengkap',
    month_expired: 'Bulan kedaluwarsa (MM/YYYY)',
    addr_line_1: 'Alamat Penagihan (baris 1)',
    addr_line_2: 'Alamat Penagihan (baris 2)',
    zip: 'Kode pos atau kode pos',
    city: 'Kota',
    country: 'Negara',
    withdraw_only_to_visa: 'Anda hanya dapat menarik dana ke kartu Visa',
    card_country_is_restricted: 'Sayangnya, kami tidak melayani penarikan dana ke kartu yang diterbitkan di {country}',
  },
  twofa: {
    required: 'Diperlukan autentikasi dua faktor',
    required_for_this_payment_method: 'Anda tidak dapat menggunakan metode pembayaran ini karena Anda belum menyiapkan autentikasi dua faktor.',
    you_can_start_now: 'Anda bisa memulai proses penyiapannya sekarang.',
    setup: 'Siapkan 2FA',
    why_we_require: 'Klik untuk membaca - Mengapa kami memerlukan 2FA untuk penarikan dana?',
  },
  password_strong: {
    minimum: 'Kata sandi harus terdiri dari setidaknya {value} karakter',
    maximum: 'Kata sandi harus terdiri dari paling sedikit {value} karakter',
    lowercase: 'Kata sandi harus terdiri dari minimal 1 karakter huruf kecil',
    uppercase: 'Kata sandi harus terdiri dari minimal 1 karakter huruf besar',
    numeric: 'Kata sandi harus memiliki setidaknya 1 karakter numerik',
    special: 'Kata sandi harus memiliki setidaknya 1 karakter khusus',
  },
  help_center: {
    help_center: 'Pusat bantuan',
    hello: 'Halo, ada yang bisa kami bantu?',
    create_ticket: 'buat tiket',
    contact_us: 'Hubungi kami',
    guide: 'Panduan',
    top_articles: 'Artikel teratas',
    didnt_find: 'Tidak menemukan yang Anda butuhkan?',
    article: 'Artikel',
    general: 'Umum',
    fees: 'Biaya',
    buying_selling: 'Membeli & Menjual',
    deposit_withdrawal: 'Deposit & Penarikan Dana',
    refunds: 'Pengembalian Dana',
    user_account: 'Akun Pengguna',
    affiliate: 'Afiliasi',
    partnership: 'Kemitraan',
    scam: 'Dugaan penipuan',
    was_helpful: 'Apakah artikel ini bermanfaat?',
    found_helpful: '{yes} dari {max} menemukan yang bermanfaat',
    faq: '<span class="color-primary">Pertanyaan yang sering diajukan</span>',
  },
};
